import { Fragment, useState, useEffect } from 'react';
import Router, { useRouter } from 'next/router';
import Head from 'next/head';
import Link from '@/components/zone-link';
import styles from './general_admission.module.css';
import { ShoppingCartOutlined, Close, Warning, CheckCircleOutline, InfoOutlined, Add, Remove, KeyboardArrowDown, KeyboardArrowUp, LockOutlined, PhoneIphone, VerifiedUser } from '@mui/icons-material';
import Divider from '@mui/material/Divider';
import { getContrast, getHoldToken, clearHoldToken, addAffiliateCookie, CurrencySymbol, getStripePublicKey } from "@/lib/site";
import { OpeningCountdown } from './index';
import * as fbq from "@/lib/fbq";
import * as gtag from "@/lib/gtag";
import axios from 'axios';
import cookie from "js-cookie";
import { DateTime } from 'luxon';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ExpressCheckoutElement, useElements, useStripe } from '@stripe/react-stripe-js';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { Archivo_Black, Manrope, JetBrains_Mono } from 'next/font/google';

const archivoBlack = Archivo_Black({ subsets: ['latin'], weight: '400', display: 'swap', variable: '--font-archivo-black' });
const manrope = Manrope({ subsets: ['latin'], display: 'swap', variable: '--font-manrope' });
const jetbrainsMono = JetBrains_Mono({ subsets: ['latin'], display: 'swap', variable: '--font-jetbrains-mono' });

export default function GeneralAdmission({ event={"banner_image":undefined}, org={"background_color":"FFFFFF","favicon":undefined,"country_id":0}, stripe_account={"stripe_user_id":undefined}, venue, add_ons=[], questions=[], tracking_pixels=[], server_time }){
	const [error, setError] = useState(undefined);
	const [selected, setSelected] = useState([]);
	const [selectedLoading, setSelectedLoading] = useState(false);
	const [amount, setAmount] = useState(0);
	const [deliveryOption, setDeliveryOption] = useState(0);
	const [deliveryCost, setDeliveryCost] = useState(0);
	const [transactionFee, setTransactionFee] = useState(0);
	const [loadingCategories, setLoadingCategories] = useState(true);
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(true);
	const [tickets, setTickets] = useState([]);
	const [filtered, setFiltered] = useState(undefined);
	const [displayUnlockedCodes, setDisplayUnlockedCodes] = useState(false);
	const [urlUnlockCode, setUrlUnlockCode] = useState(undefined);
	const [urlUnlockPromotion, setUrlUnlockPromotion] = useState(undefined);
	const [unlockedArray, setUnlockedArray] = useState([]);
	const [specialInstructionsLoading, setSpecialInstructionsLoading] = useState(true);
	const [specialInstructions, setSpecialInstructions] = useState(undefined);
	const [ticketDescriptions, setTicketDescriptions] = useState({});
	const [showApplePay, setShowApplePay] = useState(false);
  	const [showGooglePay, setShowGooglePay] = useState(false);
  	const [clientSecret, setClientSecret] = useState(undefined);
  	const [offerExpressCheckout, setOfferExpressCheckout] = useState(false);
  	const [expressCheckoutTotal, setExpressCheckoutTotal] = useState(0);
  	const [displayExpressCheckoutModal, setDisplayExpressCheckoutModal] = useState(false);
	const [paymentSubmitLoading, setPaymentSubmitLoading] = useState(false);
    const [expressPaymentMethod, setExpressPaymentMethod] = useState(undefined);
    const [companionRules, setCompanionRules] = useState([]);
	const [loadingCompanionRules, setLoadingCompanionRules] = useState(true);
	const [accepted, setAccepted] = useState(false);

	const router = useRouter();
	const stripePromise = loadStripe(getStripePublicKey({country_id:org.country}),{stripeAccount:stripe_account.stripe_user_id});

	useEffect(() => { 
		if( router.query.filter != undefined ){ setFiltered(router.query.filter.split(",").map(str => parseInt(str))); };
		if( router.query.unlock_code != undefined ){ setUrlUnlockCode( router.query.unlock_code ) };
		if( router.query.promotion_code != undefined ){ setUrlUnlockPromotion( router.query.promotion_code ) };
		if( router.query.affiliate_code != undefined ){ addAffiliateCookie( event.event_id, router.query.affiliate_code ); }
		if (router.isReady && router.query.token != undefined ){ const get_token = cookie.get("token"); if( get_token === undefined ){ cookie.set("token", router.query.token, { expires: 0.99, sameSite: 'none', secure: true, path: '/' }); } }
	}, [router.isReady]);
	useEffect(() => { runFilter(); }, [filtered,loading]);
	useEffect(() => { 
		if( event.absorb_ticket_fees === 0 ){
			setAmount(selected.reduce((total,item) => total + ( ( item.total_cost * item.tickets_included ) * item.units ), 0 ));
		} else {
			setAmount(selected.reduce((total,item) => total + ( ( ( item.total_cost * item.tickets_included ) - ( item.fees * item.tickets_included ) ) * item.units ), 0 ));
		}
	}, [selected]);
	useEffect(() => { calculateTransactionFee(); displayApplePayGooglePay(selected,amount); }, [amount]);
	useEffect(() => { 
		loadCategories(); 
		loadTickets();
		loadCompanionRules();
		offerExpressCheckoutCheck();
		if (typeof window !== 'undefined'){
			const navigationEntries = performance.getEntriesByType('navigation');
			if( navigationEntries.length > 0 && navigationEntries[0].type === 'reload' ){
				// if reload - clear cart
				cookie.remove( "timeout_" + getHoldToken() );
				cookie.remove( 'intix_JSHQ688DNZ' );
				clearHoldToken();
			}
		}
	}, []);
	useEffect(() => { axios.get('https://d2jun3ty2bmcrf.cloudfront.net/event/' + event.event_id + '/special_instructions.txt').then(res => { setSpecialInstructions(res.data); setSpecialInstructionsLoading(false); }).catch((error) => { setSpecialInstructionsLoading(false); }); }, []);
	useEffect(() => { if(tickets.length > 0 ){ if(tracking_pixels.some(e => e.type === 'google_tag') || tracking_pixels.some(e => e.type === 'google_analytics')){ for(var z = 0; z < tickets.length; z++){ gtag.event('view_item', {currency: event.currency, items: [{item_id: tickets[z].price_id, item_name: tickets[z].title, affiliation: event.title, price: ( tickets[z].total_cost / 100 ).toFixed(2), index: 0 }]}); } } } }, [tickets, tracking_pixels]);

	function displayApplePayGooglePay( selected, amount ){
		if( selected.length === 0 ){ setShowApplePay(false); setShowGooglePay(false); return; }
		if( amount === 0 ){ setShowApplePay(false); setShowGooglePay(false); return; }
		if( window.ApplePaySession && window.ApplePaySession.canMakePayments() ){ setShowApplePay(true); }
		if( window.PaymentRequest ){
			const request = new PaymentRequest([{
				supportedMethods: 'https://google.com/pay',
				data: {
					apiVersion: 2, apiVersionMinor: 0,
					allowedPaymentMethods: [{
						type: 'CARD',
						parameters: { allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'], allowedCardNetworks: ['VISA', 'MASTERCARD', 'AMEX'] },
						tokenizationSpecification: { type: 'PAYMENT_GATEWAY', parameters: { gateway: 'stripe', 'stripe:publishableKey': getStripePublicKey({country_id:org.country}) } }
					}]
				}
			}], { total: { label: 'Total', amount: { currency: event.currency, value: ( amount / 100 ).toFixed(2) } } });

			request.canMakePayment().then(result => { if( result ){ setShowGooglePay(true); } }).catch(error => { console.log("Google Pay check skipped"); console.log(error); });
		}
	}

	function handleUnitsOnChange(title,price_category_id,price_id,total_cost,units,fees,group_ticket,tickets_included){
		setError(undefined);
		setSelected(prevSelected => {
	        let data = [...prevSelected];
	        let selectedIndex = data.findIndex(d => d.price_id == price_id);
	        
	        if (selectedIndex !== -1) {
	            data[selectedIndex] = { ...data[selectedIndex], units };
	            if (units == '0' || parseInt(units) === 0) {
	                data.splice(selectedIndex, 1);
	                gtag.event('remove_from_cart', { id: price_id, name: title, category: price_category_id, price: (total_cost / 100).toFixed(2), quantity: 0 });
	            }
	        } else {
	            data.push({ title, price_category_id, price_id, total_cost, fees, units, group_ticket, tickets_included });
	            if (tracking_pixels.some(e => e.type === 'facebook')) { fbq.event('AddToCart', { content_name: title, content_category: price_category_id, content_ids: [price_id], content_type: 'product', value: (total_cost / 100).toFixed(2), currency: event.currency }); }
	            if (tracking_pixels.some(e => e.type === 'google_tag') || tracking_pixels.some(e => e.type === 'google_analytics')) { gtag.event('add_to_cart', { currency: event.currency, value: ((total_cost / 100) * units).toFixed(2), items: [{ item_id: price_id, item_name: title, affiliation: event.title, price: (total_cost / 100).toFixed(2), quantity: units }] }); }
	            if (tracking_pixels.some(e => e.type === 'tiktok')) { ttq.track('AddToCart', { content_id: price_id, description: title, quantity: 1, currency: event.currency, value: (total_cost / 100).toFixed(2) }); }
	        }
	        
	        return validateGaCartRules(data);
	    });
	}

	function submitCheckoutZero(){
		const wait = Math.random() * ( 4000 );
		setSelectedLoading(true);
		const timeout = setTimeout(() => {
			fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/add_general_admission', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() }, body: JSON.stringify({ selected_prices: selected, event_id: event.event_id, hold_token: parseInt( getHoldToken() ), timeout: event.purchase_timeout }) })
			.then(response => response.json())
			.then(data => { if(data.error){ setError(data.error.message); setSelectedLoading(false); } else { window.location.assign( '/checkout/?event_url=' + event.url_string + "&token=" + getHoldToken() + ( ( urlUnlockPromotion != undefined ) ? ( "&promotion_code=" + urlUnlockPromotion ) : '') ); fbq.event('InitiateCheckout',{}); gtag.event('begin_checkout',{currency: event.currency, value: ( data.cart_value / 100 ).toFixed(2), items:[]}); if(tracking_pixels.some(e => e.type === 'tiktok')){ ttq.track('InitiateCheckout',{}); } } })
			.catch(error => { setError(error.message); });
		}, wait);
	}

	function submitExpressCheckoutButton(){
		setSelectedLoading(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/add_general_admission', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() }, body: JSON.stringify({ selected_prices: selected, event_id: event.event_id, hold_token: parseInt( getHoldToken() ), timeout: event.purchase_timeout }) })
		.then(response => response.json())
		.then(data => { 
			if(data.error){ 
				setError(data.error.message); 
				setSelectedLoading(false); 
			} else { 
				fbq.event('InitiateCheckout',{}); 
				gtag.event('begin_checkout',{currency: event.currency, value: ( data.cart_value / 100 ).toFixed(2), items:[]}); 
				if(tracking_pixels.some(e => e.type === 'tiktok')){ ttq.track('InitiateCheckout',{}); }
				fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/express_checkout_session', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': cookie.get("token"), 'Hold-Token': getHoldToken() }, })
				.then(response => response.json())
				.then(data => { setClientSecret(data.client_secret); setExpressCheckoutTotal(data.checkout_total); setDisplayExpressCheckoutModal(true); })
				.catch(error => { setError('There was an error creating the transaction. Please try another payment method.'); setSelectedLoading(false); });
			} 
		})
		.catch(error => { setError(error.message); });
	}

	function calculateTransactionFee(){
		if( amount > 0 ){
			setSelectedLoading(true);
			fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/cart_transaction_fee?amount=' + amount, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() } })
			.then(response => response.json())
			.then(data => { setTransactionFee(data) })
			.catch(error => { setError(error.message); })
			.finally(() => { setSelectedLoading(false); });
		} else {
			setTransactionFee(0)
		}
	}

	function loadCategories(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/ticket_category', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.json())
		.then(data => { if(data.error){  } else { setCategories(data); } })
		.catch(error => { setError(error.message); })
		.finally(() => { setLoadingCategories(false); });
	}

	function loadTickets(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/general_admission', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.json())
		.then(res => { 
			if(res.error){  

			} else { 
				setTickets(res.data);
				const descriptionPromises = res.data.map(t =>
					axios.get('https://d2jun3ty2bmcrf.cloudfront.net/event/' + event.event_id + '/price_category/' + t.price_category_id + '/price/' + t.price_id + '/description.txt')
					.then(r => ({ id: t.price_id, text: r.data }))
					.catch(() => ({ id: t.price_id, text: null }))
				);
				Promise.all(descriptionPromises).then(results => {
					const descMap = results.reduce((acc, curr) => ({...acc, [curr.id]: curr.text}), {});
					setTicketDescriptions(descMap);
				});

				setDisplayUnlockedCodes(res.locked_tickets); 
				if( res.data.length === 1 && res.data[0].max_units === 1 && res.locked_tickets === false ){ 
					handleUnitsOnChange( res.data[0].title, res.data[0].price_category_id, res.data[0].price_id, res.data[0].total_cost, 1, res.data[0].fees, res.data[0].group_ticket, res.data[0].tickets_included ); 
				} 
			} 
		})
		.catch(error => { setError(error.message); })
		.finally(() => { setLoading(false); });
	}

	function loadCompanionRules() {
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/companion_ticketing', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.ok ? response.json() : Promise.reject('fetch error'))
		.then(data => { if (!data.error) setCompanionRules(data.data); updateTicketsMap(); })
		.catch(error => { console.log(error); })
		.finally(() => { setLoadingCompanionRules(false); });
	}

	function validateGaCartRules(currentCart) {
	    if (!companionRules || companionRules.length === 0) return currentCart;
	    let validCart = [...currentCart];

	    companionRules.forEach(rule => {
	        const cartCounts = getCartCounts(validCart);

	        const timesTriggered = Math.min(
	            ...rule.requirements.map(req => 
	                Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity)
	            )
	        );
	        const maxAllowed = timesTriggered * rule.reward_quantity;
	        const currentRewardCount = cartCounts[rule.reward_price_id] || 0;

	        if (currentRewardCount > maxAllowed) {
	            let excessToRemove = currentRewardCount - maxAllowed;
	            
	            // Walk backwards through cart, reducing units on reward lines
	            for (let i = validCart.length - 1; i >= 0 && excessToRemove > 0; i--) {
	                if (validCart[i].price_id !== rule.reward_price_id) continue;
	                const lineUnits = parseInt(validCart[i].units || 0);
	                
	                if (lineUnits <= excessToRemove) {
						excessToRemove -= lineUnits;
						validCart.splice(i, 1);
					} else {
						validCart[i] = { ...validCart[i], units: lineUnits - excessToRemove };
						excessToRemove = 0;
					}
	            }
	        }
	    });

	    return validCart;
	}

	function getCartCounts(cart) {
		return cart.reduce((acc, item) => {
			const id = item.price_id;
			const qty = parseInt(item.units || 0);
			acc[id] = (acc[id] || 0) + qty;
			return acc;
		}, {});
	}

	function runFilter(){
		if( filtered != undefined && loading === false ){ setTickets(tickets.filter(item => filtered.find(obj => obj === item.price_category_id))) }
	}

	function openTicketSales(){ window.location.reload(false); }
	function unlockCodeCorrect(array){ setUnlockedArray(array); }
	function togglePaymentSubmitLoading( value ){ setPaymentSubmitLoading(value); }
	function toggleExpressCheckoutModal( value ){ 
		setDisplayExpressCheckoutModal(value); 
		setSelectedLoading(value); 
		//cookie.remove( "timeout_" + getHoldToken() );
		//cookie.remove( 'intix_JSHQ688DNZ' );
		//clearHoldToken();
		//setSelected([]);
	}
	function offerExpressCheckoutCheck(){
		if( add_ons.length > 0 ){ setOfferExpressCheckout(false); return; }
		if( questions.length > 0 ){ setOfferExpressCheckout(false); return; }
		if( event.offer_guest_checkout ){ setOfferExpressCheckout(true); }
	}

	if( !server_time ){
		return ( <div id={"ticketSelect"} className={styles.modalContainer}><div className={styles.modalPanel}><main className={styles.modalMain}><div className={styles.modalContent}><div className={styles.modalContentParent}><div className={styles.modalContentChildren}>Invalid server timestamp</div></div></div></main></div></div> )
	}

	if( server_time < event.utc_booking_start_date ){
		return ( <div id={"ticketSelect"} className={styles.modalContainer}><div className={styles.modalPanel}><main className={styles.modalMain}><div className={styles.modalContent}><div className={styles.modalContentParent}><div className={styles.modalContentChildren}>TICKETS ARE NOT OPEN YET</div></div></div></main></div></div> )
	}

	if( server_time > event.utc_booking_finish_date ){
		return ( <div id={"ticketSelect"} className={styles.modalContainer}><div className={styles.modalPanel}><main className={styles.modalMain}><div className={styles.modalContent}><div className={styles.modalContentParent}><div className={styles.modalContentChildren}><p>TICKETS ON SALE FOR THIS EVENT HAVE NOW CLOSED</p></div></div></div></main></div></div> )
	}

	return (
		<Fragment>
			<Head>
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="x-default" />
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="en" />
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="en-us" />
				<link rel="alternate" href={"https://www.intix.com.au/event/" + event.url_string} hrefLang="en-au" />
				<link rel="alternate" href={"https://www.intix.co.uk/event/" + event.url_string} hrefLang="en-gb" />
				<link rel="alternate" href={"https://www.intix.co.nz/event/" + event.url_string} hrefLang="en-nz" />
				<link rel="alternate" href={"https://www.intix.ch/event/" + event.url_string} hrefLang="gsw" />
				{tracking_pixels.filter(e => e.type == 'facebook').map((item,index) => ( <script key={"facebook_pixel_" + index} id={"fb-pixel-" + index} dangerouslySetInnerHTML={{__html:`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', ${item.pixel});` }} /> ))}
				{tracking_pixels.filter(e => e.type == 'google_analytics').map((item,index) => ( <Fragment key={"ga4-" + index}><script async src={"https://www.googletagmanager.com/gtag/js?id=" + item.pixel}></script><script key={"google_analytics_" + index} id={"google-tag-" + index} dangerouslySetInnerHTML={{__html:`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${item.pixel}');` }} /></Fragment> ))}
				{tracking_pixels.filter(e => e.type == 'google_tag').map((item,index) => ( <Fragment key={"gtm-" + index}><script async src={"https://www.googletagmanager.com/gtag/js?id=" + item.pixel}></script><script key={"google_tag_" + index} id={"gtm-" + index} dangerouslySetInnerHTML={{__html:`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${item.pixel}');` }} /></Fragment> ))}
				{tracking_pixels.filter(e => e.type == 'tiktok').map((item,index) => ( <script key={"tiktok_" + index} id={"tiktok-tag-" + index} dangerouslySetInnerHTML={{__html:`!function (w, d, t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load('${item.pixel}');ttq.page();}(window, document, 'ttq');` }} /> ))}
			</Head>
			<div id={"ticketSelect"} className={styles.modalContainer}>
				<div className={styles.modalPanel}>
					<Header event_id={event.event_id} online_event={event.online_event} venue_id={event.venue_id} banner_image={event.banner_image} background_color={org.background_color} org_url_string={org.url_string} favicon={org.favicon} org_title={org.title} event_title={event.title} venue_title={venue.title} utc_event_start_date={event.utc_event_start_date} timezone={event.timezone} ga_event_start_date={event.ga_event_start_date} ga_event_finish_date={event.ga_event_finish_date} event_url_string={event.url_string} country={org.country} />
					<main className={styles.modalMain}>
						<div className={styles.modalContent}>
							{error != undefined ? ( <div className={styles.generalAdmissionErrorMessage}><div className={styles.generalAdmissionErrorPadding} dangerouslySetInnerHTML={{__html: error}}></div></div> ) : null}
							<div className={styles.modalContentParent}>
								<div className={styles.modalContentChildren}>
									{loadingCategories === true || loading === true ? (
										<div className={styles.ivUHTG}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg" alt="Loading" title="Loading" width="100" /></div>
									) : (
										<Fragment>
											{specialInstructions != undefined && specialInstructions != '' ? ( <div className={styles.tGBnzt} dangerouslySetInnerHTML={{__html:specialInstructions}}></div> ) : null}
											{displayUnlockedCodes ? ( <UnlockPromoCode event_id={event.event_id} unlock_code_correct={unlockCodeCorrect} url_unlock_code={urlUnlockCode} accepted={accepted} set_accepted={setAccepted} /> ) : null}
											{unlockedArray.length > 0 && categories.length === 0 ? ( <TicketSelection event_id={event.event_id} event_type={event.event_type} ticket_category_id={0} tickets={unlockedArray} categories={[]} currency={event.currency} submit_checkout_zero={submitCheckoutZero} handle_units_on_change={handleUnitsOnChange} absorb_ticket_fees={event.absorb_ticket_fees} loading={loading} ticket_resale={event.ticket_resale} event_url_string={event.url_string} display_unlocked_codes={displayUnlockedCodes} selected={selected} ticket_descriptions={ticketDescriptions} companion_rules={companionRules} accepted={accepted} /> ) : null}
											{categories.length > 0 ? (
												<Fragment>
													{categories.map((item,index) => (
														<Fragment key={"category_" + item.ticket_category_id}>
															{tickets.some(o => o.ticket_category_id === item.ticket_category_id) ? ( 
																<div key={"category_" + item.ticket_category_id} >
																	{item.banner_image != null ? ( <img className={styles.pInjy7} src={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + item.banner_image} alt={item.title} title={item.title} /> ) : ( <div className={styles.gBNy6f} style={{backgroundColor:"#"+org.background_color,color:getContrast(org.background_color)}}>{item.title}</div> )}
																	<TicketSelection event_id={event.event_id} ticket_category_id={item.ticket_category_id} categories={categories} tickets={tickets} currency={event.currency} submit_checkout_zero={submitCheckoutZero} handle_units_on_change={handleUnitsOnChange} absorb_ticket_fees={event.absorb_ticket_fees} loading={loading} ticket_resale={event.ticket_resale} event_url_string={event.url_string} display_unlocked_codes={displayUnlockedCodes} selected={selected} ticket_descriptions={ticketDescriptions} companion_rules={companionRules} accepted={accepted} />
																</div>
															) : null}
															{unlockedArray.some(o => o.ticket_category_id === item.ticket_category_id) ? ( 
																<div key={"category_" + item.ticket_category_id} >
																	{item.banner_image != null ? ( <img className={styles.pInjy7} src={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + item.banner_image} alt={item.title} title={item.title} /> ) : ( <div className={styles.gBNy6f} style={{backgroundColor:"#"+org.background_color,color:getContrast(org.background_color)}}>{item.title}</div> )}
																	<TicketSelection event_id={event.event_id} ticket_category_id={item.ticket_category_id} categories={categories} tickets={unlockedArray} currency={event.currency} submit_checkout_zero={submitCheckoutZero} handle_units_on_change={handleUnitsOnChange} absorb_ticket_fees={event.absorb_ticket_fees} loading={loading} ticket_resale={event.ticket_resale} event_url_string={event.url_string} display_unlocked_codes={displayUnlockedCodes} selected={selected} ticket_descriptions={ticketDescriptions} companion_rules={companionRules} accepted={accepted} />
																</div>
															) : null}
														</Fragment>
													))}
												</Fragment>
											) : null}
											<TicketSelection event_id={event.event_id} event_type={event.event_type} ticket_category_id={0} tickets={tickets} categories={categories} currency={event.currency} submit_checkout_zero={submitCheckoutZero} handle_units_on_change={handleUnitsOnChange} absorb_ticket_fees={event.absorb_ticket_fees} loading={loading} ticket_resale={event.ticket_resale} event_url_string={event.url_string} selected_loading={selectedLoading} display_unlocked_codes={displayUnlockedCodes} selected={selected} ticket_descriptions={ticketDescriptions} companion_rules={companionRules} accepted={accepted} />
										</Fragment>
									)}
								</div>
							</div>
							<div className={styles.modalFooterBackground} id="gaCheckoutFooter">
								<div className={styles.modalFooterPadding}>
									<nav className={styles.modalButtonBar}>
										<div className={styles.modalButtonBarSecondary}>
											<div className={styles.paymentButtonsFlex}>
												<button disabled={selected.length === 0 || selectedLoading} className={styles.modalButton} type="button" onClick={e => submitCheckoutZero()}>{ selectedLoading === true && selected.length > 0 ? ( <img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/button-loading.svg" width="25" alt="Loading..." title="Loading..." /> ) : event.event_type === 0 ? 'Checkout' : 'Continue'}</button>
												{offerExpressCheckout ? (
													<Fragment>
														{showApplePay ? ( <button disabled={selected.length === 0 || selectedLoading || amount === 0} className={styles.applePayButton} onClick={e => { submitExpressCheckoutButton(); setExpressPaymentMethod('apple_pay'); }}>{ selectedLoading === true && selected.length > 0 ? ( <img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/button-loading.svg" width="25" alt="Loading..." title="Loading..." /> ) : ( <svg fill="#ffffff" height="20" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 210.2"><path d="M93.6,27.1C87.6,34.2,78,39.8,68.4,39c-1.2-9.6,3.5-19.8,9-26.1c6-7.3,16.5-12.5,25-12.9C103.4,10,99.5,19.8,93.6,27.1 M102.3,40.9c-13.9-0.8-25.8,7.9-32.4,7.9c-6.7,0-16.8-7.5-27.8-7.3c-14.3,0.2-27.6,8.3-34.9,21.2c-15,25.8-3.9,64,10.6,85c7.1,10.4,15.6,21.8,26.8,21.4c10.6-0.4,14.8-6.9,27.6-6.9c12.9,0,16.6,6.9,27.8,6.7c11.6-0.2,18.9-10.4,26-20.8c8.1-11.8,11.4-23.3,11.6-23.9c-0.2-0.2-22.4-8.7-22.6-34.3c-0.2-21.4,17.5-31.6,18.3-32.2C123.3,42.9,107.7,41.3,102.3,40.9 M182.6,11.9v155.9h24.2v-53.3h33.5c30.6,0,52.1-21,52.1-51.4c0-30.4-21.1-51.2-51.3-51.2H182.6z M206.8,32.3h27.9c21,0,33,11.2,33,30.9c0,19.7-12,31-33.1,31h-27.8V32.3z M336.6,169c15.2,0,29.3-7.7,35.7-19.9h0.5v18.7h22.4V90.2c0-22.5-18-37-45.7-37c-25.7,0-44.7,14.7-45.4,34.9h21.8c1.8-9.6,10.7-15.9,22.9-15.9c14.8,0,23.1,6.9,23.1,19.6v8.6l-30.2,1.8c-28.1,1.7-43.3,13.2-43.3,33.2C298.4,155.6,314.1,169,336.6,169z M343.1,150.5c-12.9,0-21.1-6.2-21.1-15.7c0-9.8,7.9-15.5,23-16.4l26.9-1.7v8.8C371.9,140.1,359.5,150.5,343.1,150.5z M425.1,210.2c23.6,0,34.7-9,44.4-36.3L512,54.7h-24.6l-28.5,92.1h-0.5	l-28.5-92.1h-25.3l41,113.5l-2.2,6.9c-3.7,11.7-9.7,16.2-20.4,16.2c-1.9,0-5.6-0.2-7.1-0.4v18.7C417.3,210,423.3,210.2,425.1,210.2z"/></svg> )}</button> ) : null}
														{showGooglePay ? ( <button disabled={selected.length === 0 || selectedLoading || amount === 0} className={styles.googlePayButton} onClick={e => { submitExpressCheckoutButton(); setExpressPaymentMethod('google_pay'); }}>{ selectedLoading === true && selected.length > 0 ? ( <img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/button-loading-transparent.svg" width="25" alt="Loading..." title="Loading..." /> ) : ( <svg width="104" height="17" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path d="M.148 2.976h3.766c.532 0 1.024.117 1.477.35.453.233.814.555 1.085.966.27.41.406.863.406 1.358 0 .495-.124.924-.371 1.288s-.572.64-.973.826v.084c.504.177.912.471 1.225.882.313.41.469.891.469 1.442a2.6 2.6 0 0 1-.427 1.47c-.285.43-.667.763-1.148 1.001A3.5 3.5 0 0 1 4.082 13H.148V2.976zm3.696 4.2c.448 0 .81-.14 1.085-.42.275-.28.413-.602.413-.966s-.133-.684-.399-.959c-.266-.275-.614-.413-1.043-.413H1.716v2.758h2.128zm.238 4.368c.476 0 .856-.15 1.141-.448.285-.299.427-.644.427-1.036 0-.401-.147-.749-.441-1.043-.294-.294-.688-.441-1.183-.441h-2.31v2.968h2.366zm7.36 1.68c-.868 0-1.528-.259-1.981-.777-.453-.518-.679-1.239-.679-2.163V5.86h1.54v4.214c0 .579.138 1.013.413 1.302.275.29.637.434 1.085.434.364 0 .686-.096.966-.287.28-.191.495-.446.644-.763a2.37 2.37 0 0 0 .224-1.022V5.86h1.54V13h-1.456v-.924h-.084c-.196.336-.5.611-.91.826-.41.215-.845.322-1.302.322zm7.878-.616L16.352 5.86h1.722l2.016 4.858h.056l1.96-4.858H23.8l-4.41 10.164h-1.624l1.554-3.416zm8.266-6.748h1.666l1.442 5.11h.056l1.61-5.11h1.582l1.596 5.11h.056l1.442-5.11h1.638L36.392 13h-1.624L33.13 7.876h-.042L31.464 13h-1.596l-2.282-7.14zM40.7 4.824a1 1 0 0 1-.735-.301 1 1 0 0 1-.301-.735 1 1 0 0 1 .301-.735 1 1 0 0 1 .735-.301 1 1 0 0 1 .735.301 1 1 0 0 1 .301.735 1 1 0 0 1-.301.735 1 1 0 0 1-.735.301zm-.77 1.036h1.54V13h-1.54V5.86zm6.464 7.252c-.317 0-.616-.051-.896-.154a1.967 1.967 0 0 1-.686-.406c-.401-.401-.602-.947-.602-1.638V7.218h-1.246V5.86h1.246V3.844h1.54V5.86h1.736v1.358H45.75v3.36c0 .383.075.653.224.812.14.187.383.28.728.28.159 0 .299-.021.42-.063.121-.042.252-.11.392-.203v1.498c-.308.14-.681.21-1.12.21zm2.782-10.136h1.54v2.73l-.07 1.092h.07c.205-.336.511-.614.917-.833.406-.22.842-.329 1.309-.329.868 0 1.53.254 1.988.763.457.509.686 1.202.686 2.079V13h-1.54V8.688c0-.541-.142-.947-.427-1.218-.285-.27-.656-.406-1.113-.406-.345 0-.656.098-.931.294a2.042 2.042 0 0 0-.651.777 2.297 2.297 0 0 0-.238 1.029V13h-1.54V2.976zm32.619-.347v4.097h2.554c.608 0 1.11-.203 1.509-.607a1.96 1.96 0 0 0 .613-1.442c0-.546-.205-1.022-.613-1.427-.398-.415-.901-.622-1.51-.622h-2.553zm0 5.539v4.753H80.27V1.186h4.045c1.028 0 1.901.34 2.62 1.016.73.677 1.094 1.503 1.094 2.475 0 .994-.364 1.825-1.094 2.49-.708.668-1.581 1-2.62 1h-2.52v.001zm7.775 2.294c0 .394.17.722.507.984.337.262.732.393 1.185.393.641 0 1.213-.235 1.716-.704.503-.47.754-1.022.754-1.655-.476-.372-1.139-.557-1.99-.557-.62 0-1.135.148-1.55.443-.414.295-.621.66-.621 1.096m1.973-5.834c1.128 0 2.018.298 2.67.893.652.596.978 1.413.978 2.45v4.95h-1.459v-1.115h-.066c-.63.918-1.47 1.377-2.52 1.377-.896 0-1.645-.262-2.247-.787-.602-.524-.904-1.18-.904-1.966 0-.831.318-1.491.953-1.983.636-.492 1.484-.738 2.545-.738.906 0 1.653.164 2.238.492v-.345c0-.524-.21-.97-.63-1.335a2.175 2.175 0 0 0-1.475-.55c-.852 0-1.525.356-2.023 1.067L88.261 6.2c.74-1.049 1.835-1.573 3.283-1.573m12.021.263l-5.09 11.57h-1.576l1.89-4.048L95.44 4.89h1.658l2.421 5.77h.033l2.355-5.77z" fill="#FFF"/><path d="M75.631 7.143c0-.474-.04-.932-.117-1.37H69.08v2.596h3.684a3.12 3.12 0 0 1-1.362 2.05v1.686h2.199c1.288-1.174 2.03-2.91 2.03-4.962" fill="#4285F4"/><path d="M69.08 13.733c1.842 0 3.392-.598 4.522-1.628l-2.2-1.687c-.611.408-1.4.646-2.321.646-1.78 0-3.29-1.186-3.83-2.784h-2.265v1.738a6.83 6.83 0 0 0 6.095 3.715" fill="#34A853"/><path d="M65.251 8.28a4.01 4.01 0 0 1 0-2.58V3.961h-2.265a6.644 6.644 0 0 0-.727 3.028c0 1.089.262 2.117.727 3.028L65.25 8.28z" fill="#FABB05"/><path d="M69.08 2.916c1.006 0 1.907.342 2.618 1.011v.001l1.947-1.924C72.462.916 70.92.247 69.08.247a6.83 6.83 0 0 0-6.095 3.715L65.25 5.7c.54-1.597 2.05-2.783 3.83-2.783" fill="#E94235"/></g></svg> )}</button> ) : null}
													</Fragment>
												) : null}
											</div>
										</div>
									</nav>
								</div>
							</div>
						</div>
					</main>
				</div>
				<aside className={styles.rightPanel}>
					<div className={styles.aside}>
						<div className={styles.bannerImage} id="bannerImage"><img className={styles.eventImage} src={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + event.banner_image} id="bannerImageImg" alt={event.title} /></div>
						<div className={styles.shoppingCart}>
							{ selected.length === 0 ? (
								<div className={styles.emptyCart}><ShoppingCartOutlined /></div>
							) : (
								<div className={styles.orderSummaryContainer}>
									<div className={styles.orderSummaryPane}>
										<div className={styles.orderSummaryTitle}>Your Selected {event.event_type === 0 ? "Ticket" : "Registration"}s</div>
										{selectedLoading ? (
											<div>{selected.map((item, index) => ( <div key={"loading_" + index} className={styles.rQynsz}></div> ))}</div>
										) : (
											<div>
												{selected.map((item, index) => ( 
													<div className={styles.orderSummaryRow} key={"selected_" + index}>
														<div className={styles.orderGridCell}>{item.units} x {item.title} </div>
														<div className={styles.orderGridCellRight}><CurrencySymbol currency={event.currency} />{( ( ( ( item.total_cost - item.fees ) * item.tickets_included ) / 100 ) * item.units).toFixed(2)}</div>
													</div>
												))}
												{selected.reduce((total, item) => total + parseInt(item.units), 0) > 8 ? (
													<p className={styles.pdfWarning}>*more than 8 tickets cannot be sent as PDFs by email, but appear in your INTIX account online or in the INTIX app</p>
												) : null}
											</div>
										)}
										<hr className={styles.orderSummaryHR} />
										{selectedLoading ? (
											<div>
												<div className={styles.bEnsEr}></div>
												<div className={styles.rqtwzv}></div>
											</div>
										) : (
											<div>
												<div className={styles.orderSummaryRowSubTotal}>
													<div className={styles.orderGridCell}>Subtotal</div>
													<div className={styles.orderGridCellRight}><CurrencySymbol currency={event.currency} />{selected.reduce((subtotal,item) => subtotal + ( ( ( ( item.total_cost - item.fees ) * item.tickets_included ) / 100 ) * item.units ), 0 ).toFixed(2)}</div>
												</div>
												{event.absorb_ticket_fees === 0 || event.absorb_transaction_fees === 0 ? ( 
													<div className={styles.orderSummaryFees}>
														<div className={styles.orderGridCell}>Fees</div>
														<div className={styles.orderGridCellRight}>
															<CurrencySymbol currency={event.currency} />
															{event.absorb_ticket_fees === 0 ? ( 
																<Fragment>
																	{ event.absorb_transaction_fees === 0 ? (
																		<Fragment>{( selected.reduce((fee,item) => fee + ( ( ( item.fees * item.tickets_included ) / 100 ) * item.units), 0 ) + ( transactionFee / 100 ) ).toFixed(2)}</Fragment>
																	) : (
																		<Fragment>{( selected.reduce((fee,item) => fee + ( ( ( item.fees * item.tickets_included ) / 100 ) * item.units), 0 ) ).toFixed(2)}</Fragment>
																	)}
																</Fragment>
															) : ( 
																<Fragment>{( transactionFee / 100 ).toFixed(2)}</Fragment> 
															)}
														</div>
													</div>
												) : null}
											</div>
										)}
										{ deliveryOption > 0 ? (
											<div>
												<div className={styles.orderSummaryRowSubTotal}>
													<div className={styles.orderGridCell}>Delivery</div>
													<div className={styles.orderGridCellRight}><CurrencySymbol currency={event.currency} />{deliveryCost.toFixed(2)}</div>
												</div>
												<div className={styles.orderSummaryDeliveryFees}>
													<div className={styles.orderGridCell}>[[]] x e{event.event_type === 0 ? 'Ticket' : 'Registration'}</div>
													<div className={styles.orderGridCellRight}></div>
												</div>
											</div>
										) : null}
										<hr className={styles.orderSummaryHR} />
										{selectedLoading ? (
											<div><div className={styles.rQynsz}></div></div>
										) : (
											<Fragment>
												<div className={styles.orderSummaryTotalRow}>
													<div className={styles.orderGridCell}><span className={styles.totalText}>Total</span></div>
													{event.absorb_ticket_fees === 0 ? (
														<Fragment>
															{ event.absorb_transaction_fees === 0 ? (
																<div className={styles.orderGridCellRight}><span className={styles.totalText}><CurrencySymbol currency={event.currency} />{( selected.reduce((total,item) => total + ( ( ( item.total_cost * item.tickets_included ) * item.units ) / 100 ), 0 ) + ( transactionFee / 100 ) ).toFixed(2)}</span></div>
															) : (
																<div className={styles.orderGridCellRight}><span className={styles.totalText}><CurrencySymbol currency={event.currency} />{( selected.reduce((total,item) => total + ( ( ( item.total_cost * item.tickets_included ) * item.units ) / 100 ), 0 ) ).toFixed(2)}</span></div>
															)}
														</Fragment>
													) : (
														<Fragment>
															{ event.absorb_transaction_fees === 0 ? (
																<div className={styles.orderGridCellRight}><span className={styles.totalText}><CurrencySymbol currency={event.currency} />{( selected.reduce((total,item) => total + ( ( ( ( item.total_cost - item.fees ) * item.tickets_included ) * item.units ) / 100 ), 0 ) + ( transactionFee / 100 ) ).toFixed(2)}</span></div>
															) : (
																<div className={styles.orderGridCellRight}><span className={styles.totalText}><CurrencySymbol currency={event.currency} />{( selected.reduce((total,item) => total + ( ( ( ( item.total_cost - item.fees ) * item.tickets_included ) * item.units ) / 100 ), 0 ) ).toFixed(2)}</span></div>
															)}
														</Fragment>
													)}
												</div>
												{selected.reduce((r,s) => r + ( s.tickets_included * s.units), 0 ) > 8 && event.digital_ticket === 1 && event.print_ticket === 1 && event.send_pdf_ticket === 1 ? ( <div className={styles.orderSummarySubText}>When selecting more than 8 tickets, we cannot send PDF tickets by email but they are accessible through your online account or app.</div> ) : null}
												<div className={styles.orderSummarySubText}>{event.event_type === 0 ? "Tickets" : "Registrations"} are not secured until payment has been made.</div>
											</Fragment>
										)}
									</div>
								</div>
							)}
						</div>
					</div>
				</aside>
			</div>
			{displayExpressCheckoutModal ? ( <ExpressCheckoutElements stripe_promise={stripePromise} event_id={event.event_id} event_title={event.title} event_status_id={event.event_status_id} event_url_string={event.url_string} background_color={org.background_color} org_name={org.name} company={org.company} org_parent={org.parent} currency={event.currency} amount={expressCheckoutTotal} update_payment_submit_loading={togglePaymentSubmitLoading} payment_submit_loading={paymentSubmitLoading} toggle_express_checkout_modal={toggleExpressCheckoutModal} express_payment_method={expressPaymentMethod} /> ) : null}
			{paymentSubmitLoading ? ( <div className={styles.dWatLN} style={{backgroundImage:"url('https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + event.banner_image + "')"}}><div className={styles.pUNm5g}><div className={styles.bavcr5z}><div className={styles.kLLpnb7}><img className={styles.lpunh5} src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/secure-payment-processing.svg" alt="" border={0} /></div></div><div className={styles.gabNya}>Payment Processing...<br /><span>Please don't refresh this page whilst we process your booking</span></div><div className={styles.tTgbhn7y}>Loading...</div></div></div> ) : null}
		</Fragment>
	)
}

function Header({ event_id, venue_id, banner_image, background_color, org_url_string, favicon, org_title, event_title, venue_title, utc_event_start_date, timezone, ga_event_start_date, ga_event_finish_date, event_url_string, country, online_event }){
	return (
		<header className={styles.selectHeader} id="selectHeader" style={{backgroundColor:"#"+background_color}}>
			<div className={styles.tRwnmx}>
				<div style={{display: "flex", justifyContent: "space-between", minWidth: "100%"}}>
					<div style={{display: "flex", flexDirection: "row"}}>
						{favicon != undefined ? ( <img className={styles.nngtsx} src={"https://d2jun3ty2bmcrf.cloudfront.net/org/" + org_url_string + "/" + favicon} alt={org_title} title={org_title} /> ) : null}
						<div className={styles.pYqfgz}>
							<h1 style={{color:getContrast(background_color)}}>{event_title}</h1>
							{venue_id != null ? (<h5 className={styles.yTmgha} style={{color:getContrast(background_color)}}>{venue_title}</h5> ) : null}
							<h5 className={styles.yTmgha} style={{color:getContrast(background_color)}}>
								{country == 197 ? ( <Fragment>{DateTime.fromISO(DateTime.fromMillis(utc_event_start_date * 1000).toISO(), {zone: timezone}).toFormat('MMMM d, yyyy')}</Fragment> ) : ( <Fragment>{DateTime.fromISO(DateTime.fromMillis(utc_event_start_date * 1000).toISO(), {zone: timezone}).toFormat('d MMMM yyyy')}</Fragment> )}
								{ga_event_start_date === ga_event_finish_date ? ( <Fragment> @ {DateTime.fromISO(DateTime.fromMillis(utc_event_start_date * 1000).toISO(), {zone: timezone}).toFormat('h:mm a')} {online_event === 1 ? <Fragment>({timezone})</Fragment> : null}</Fragment>) : null} {ga_event_start_date != ga_event_finish_date ? ( <Fragment> to {ga_event_finish_date}</Fragment> ) : null}
							</h5>
						</div>
					</div>
					<div className={styles.eventInfo}>
						<Link href={event_url_string + "/information"} target='_blank' rel="noopener noreferrer" className={styles.eventInfoLink}>Event Info</Link>
					</div>
				</div>
			</div>
			<img src={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event_id + "/" + banner_image} className={styles.mobileBannerGaSelect} alt={event_title} />
		</header>
	)
}

function TicketSelection({ event_id, ticket_category_id, tickets, categories, handle_units_on_change, currency, submit_checkout_zero, absorb_ticket_fees, loading, event_type, ticket_resale, event_url_string, selected_loading, display_unlocked_codes, selected, ticket_descriptions, companion_rules, accepted }){
	const visible_tickets = tickets.filter((t) => t.ticket_category_id === ticket_category_id);
	const all_sold_out = visible_tickets.length > 0 && visible_tickets.every(t => t.sold_out !== 0);

	function getMaxAllowedForPrice(item) {
        const standardMax = item.tickets_remaining < item.max_units ? item.tickets_remaining : item.max_units;
        if (!companion_rules) return standardMax;
        
        const rule = companion_rules.find(r => r.reward_price_id === item.price_id);
        if (!rule) return standardMax;

        const cartCounts = selected.reduce((acc, line) => {
            const id = line.price_id;
            const qty = parseInt(line.units || 0) * (line.tickets_included || 1);
            acc[id] = (acc[id] || 0) + qty;
            return acc;
        }, {});
        
        const timesTriggered = Math.min( ...rule.requirements.map(req =>   Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity) ) );
        const ruleMax = timesTriggered * rule.reward_quantity;
        const ruleMaxUnits = Math.floor(ruleMax / (item.tickets_included || 1));
        
        return Math.min(standardMax, ruleMaxUnits);
    }

	function createSelectItems( min, max, price_id, item ){
		const effectiveMax = item ? getMaxAllowedForPrice(item) : max;
		let items = [];
		items.push(<option key={"units_" + price_id + "_0"} value={0}>-</option>);
		for (let i = min; i <= effectiveMax; i++){ items.push(<option key={"units_" + price_id + "_" + i} value={i}>{i}</option>); }
		return items;
	}

	return (
		<Fragment>
			{/* TODO: promo codes <div>Enter promo code</div> */}
			{tickets.length === 0 ? (
				<div style={{display: "flex", gap: "4px"}}>
					<p>There are currently no {event_type === 1 ? "registration options" : "tickets"} available</p>
					<span className={styles.ticketPrice}>
						{ticket_resale === 1 ? ( <p style={{lineHeight: "21px"}}><Link href={"/event/" + event_url_string + "/resale"}> - check through resale.</Link></p>) : null}
					</span>
				</div>
			) : ( 
				<>
				<div className={styles.ticketSelectionList}>
					<div className={styles.ticketsContainer}>
						<ul id={"ticket_selection_list"}>
							{tickets.filter(obj => obj.ticket_category_id === ticket_category_id).map((item, index) => ( 
								<li id={"ticket_selection_" + ticket_category_id + "_" + item.price_id} key={"ticket_selection_" + item.price_category_id + "_" + item.price_id} className={styles.cardListItem}>
									<div className={styles.cardSimple}>
										<div className={styles.cardContainer}>
											<div className={styles.ticketCardContent}>
												<div className={styles.ticketCardContentBody}>
													<div className={styles.ticketCardPrimaryContent}>
														<div>
															<h3 className={styles.ticketTitle}>{item.title}</h3>
															<div>
																{ticket_resale === 1 && item.ticket_resale === 1 && item.sold_out === 1 ? (
																	<div className={styles.priceSoldOut}>SOLD OUT</div> 
																) : ( 
																	<div className={styles.priceInformation}>
																		<span className={styles.ticketPrice}><CurrencySymbol currency={currency} />{( ( ( item.total_cost * item.tickets_included ) - ( item.fees * item.tickets_included ) ) / 100 ).toFixed(2)}</span>
																		{/* {absorb_ticket_fees === 0 && item.fees != 0 ? ( <span className={styles.feeInformation}>Plus <CurrencySymbol currency={currency} />{( ( item.fees * item.tickets_included ) / 100 ).toFixed(2)} Fees</span> ) : null} */}
																	</div>
																)}
															</div>
														</div>
														<div className={styles.aScvbT}>
															{ item.sold_out === 0 && item.tickets_remaining < 15 ? ( <div className={styles.highDemand}>{event_type === 1 ? "LAST AVAILABLE" : "LAST TICKETS"}</div> ) : null}
															<div className={styles.quantitySelector}>
																{item.sold_out === 0 ? (
																	<div className={styles.borderSimulation}>
																		<div className={styles.fieldStyledInternal}>
																			<div className={styles.fieldStyledInputContainer}>
																				<select disabled={selected_loading} className={styles.quantitySelect} onChange={e => handle_units_on_change( item.title, item.price_category_id, item.price_id, item.total_cost, e.target.value, item.fees, item.group_ticket, item.tickets_included )}>{createSelectItems( item.min_units, ( item.tickets_remaining < item.max_units ? item.tickets_remaining : item.max_units ), item.price_id, item )}</select>
																			</div>
																		</div>
																	</div>
																) : ( <Fragment>{ticket_resale === 1 && item.ticket_resale === 1 ? ( <Link href={"/event/" + event_url_string + "/resale"}>CHECK RESALE</Link> ) : ( <div className={styles.soldOut}>SOLD OUT</div> )}</Fragment> )}
															</div>
														</div>
													</div>
													<div className={styles.ticketCardSecondaryContent}>
														<span className={styles.ticketStatus}>
															{(() => {
																const rule = companion_rules?.find(r => r.reward_price_id === item.price_id);
																if (!rule) return null;

																const cartCounts = selected.reduce((acc, line) => {
																	const id = line.price_id;
																	const qty = parseInt(line.units || 0) * (line.tickets_included || 1);
																	acc[id] = (acc[id] || 0) + qty;
																	return acc;
																}, {});

																const timesTriggered = Math.min( ...rule.requirements.map(req => Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity) ) );
																const maxAllowed = timesTriggered * rule.reward_quantity;

																if (maxAllowed === 0){
																	const requirementText = rule.requirements.map(req => {
																		const trigger = tickets.find(t => t.price_id === req.trigger_price_id);
																		return `${req.trigger_quantity} × ${trigger?.title || 'qualifying ticket'}`;
																	}).join(' and ');
																	return <div className={styles.ticketUnlock}>🔒 Add {requirementText} to unlock</div>;
																}

																return <div className={styles.ticketUnlockAvailable}>✓ {maxAllowed} available with your current cart</div>;
															})()}
														</span>
														<TicketSummaryText text={ticket_descriptions[item.price_id]} price_id={item.price_id} />
														{selected.reduce((total, item) => total + parseInt(item.units), 0) > 8 && 
														 selected.findLast(selectedItem => parseInt(selectedItem.units) > 0)?.price_id === item.price_id ? (
															<p className={styles.pdfWarning} style={{textAlign: "end", marginRight: "1px"}}>*more than 8 tickets cannot be sent as PDFs by email, but appear in your INTIX account online or in the INTIX app</p>
														) : null}
													</div>
												</div>
											</div>
										</div>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
				{all_sold_out &&
					<div style={{display: "flex", gap: "4px"}}>
						{!accepted ? (
							<>
							<p>There are currently no {event_type === 1 ? "registration options" : "tickets"} available</p>
							<span className={styles.ticketPrice}>
								{ticket_resale === 1 ? ( <p style={{lineHeight: "21px"}}><Link href={"/event/" + event_url_string + "/resale"}> - check through resale.</Link></p>) : null}
							</span>
							</>
						) : (
							<>
							<span className={styles.ticketPrice}>
								{ticket_resale === 1 ? ( <p style={{lineHeight: "21px"}}><Link href={"/event/" + event_url_string + "/resale"}>Check through resale.</Link></p>) : null}
							</span>
							</>
						)}
					</div>
				}
				</>
			)}
		</Fragment>
	)
}

export function UnlockPromoCode({ event_id, unlock_code_correct, url_unlock_code, accepted, set_accepted }){
	const [loading, setLoading] = useState(false);
	const [code, setCode] = useState('');
	const [error, setError] = useState(undefined);

	useEffect(() => { if( url_unlock_code != undefined && url_unlock_code != '' ){ setCode(url_unlock_code); validateCode(url_unlock_code); } }, [url_unlock_code]);

	function validateCode( value ){
		setLoading(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event_id + '/general_admission/unlock', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password: value }) })
		.then(response => response.json())
		.then(data => { if(data.error){ setError(data.error.message); } else { unlock_code_correct(data.data); set_accepted(true); } })
		.catch(error => { setError(error.message); })
		.finally(() => { setLoading(false); });
	}

	return (
		<div className={styles.ppUNbx}>
			<form className={styles.qTGBxz} onSubmit={e => { e.preventDefault(); validateCode( code ); }}>
				<div className={styles.rTABz1}>
					<div className={styles.luYHnx}>
						<div className={error === undefined ? styles.aTTRbx : styles.pUUyx9}>
							<div className={styles.lYTcv5}>
								<input id={"promo_code_input_" + event_id} className={styles.jht5cx} disabled={accepted || loading} onChange={e => { setCode(e.target.value); setError(undefined)}} value={code} type="text" placeholder="Enter code" title="Unlock Code" name="promo-code" />
								<label className={error === undefined ? styles.aRRvbx : styles.ouYVxa}>Unlock Code</label>							
							</div>
							<span className={styles.tGBzt1}>{accepted === true ? ( <span className={styles.tGBa5x}><CheckCircleOutline /></span> ) : null}</span>
							<span className={styles.raBN6x}>{error != undefined ? ( <span className={styles.yUBc5x}><Warning /></span> ) : accepted === true ? ( <button id={"promo_code_remove_" + event_id} type={"button"} className={styles.uIVBNz} onClick={e => { set_accepted(false); unlock_code_correct([])}}>Remove</button> ) : ( <button id={"promo_code_submit_" + event_id} type={"button"} onClick={e => validateCode(code)} disabled={code.length < 2 || loading} className={styles.iaytcx}><span className={styles.bNGT5x}>Apply</span></button> )}</span>
						</div>
						<aside className={styles.vvoiab}><label className={error === undefined ? styles.aTBvxz : styles.rTVbza}>{error}{accepted === true ? code + " applied. New tickets unlocked below." : null}</label></aside>
					</div>
				</div>
			</form>
		</div> 
	)
}

function TicketSummaryText({ text, price_id }){
	const [readMore, setReadMore] = useState(false);

	if( text === undefined ){ return null }
	if( !text || text.length === 0 ) { return null; }

	return ( 
		<div className={styles.ticketDescription}>
			{text.length > 75 && readMore === false ? (
				<div className={styles.readMore}>
					<div dangerouslySetInnerHTML={{__html: text.substring(0,75) + "..."}}></div>
					<button id={"read_less_" + price_id} className={styles.readMoreToggle} onClick={e => setReadMore(true)}>Read More</button>
				</div>
			) : (
				<Fragment>
					<div className={styles.readMore} dangerouslySetInnerHTML={{__html: text}}></div>
					{text.length > 75 ? ( <button id={"read_less_" + price_id} className={styles.readMoreToggle} onClick={e => setReadMore(false)}>Read Less</button> ) : null}
				</Fragment>
			)}
		</div> 
	)
}

function ExpressCheckoutElements({ stripe_promise, client_secret, event_id, event_title, event_status_id, event_url_string, background_color, org_name, org_parent, company, currency, amount, update_payment_submit_loading, payment_submit_loading, toggle_express_checkout_modal, express_payment_method }){
	const payment_method_types = ['card'];
	const options = { mode: 'payment', currency: currency.toLowerCase(), amount: amount, paymentMethodTypes: payment_method_types, appearance: { theme: 'stripe', variables: { colorBackground: '#' + background_color, colorPrimary: getContrast(background_color) } } };

	return (
		<Elements stripe={stripe_promise} options={options} key={client_secret}>
			<ExpressPurchase event_id={event_id} event_title={event_title} event_status_id={event_status_id} event_url_string={event_url_string} background_color={background_color} org_name={org_name} org_parent={org_parent} company={company} currency={currency} amount={amount} update_payment_submit_loading={update_payment_submit_loading} payment_submit_loading={payment_submit_loading} toggle_express_checkout_modal={toggle_express_checkout_modal} express_payment_method={express_payment_method} /> 
		</Elements>
	)
}

function ExpressPurchase({ event_id, event_title, event_status_id, event_url_string, background_color, company, org_name, org_parent, currency, amount, update_payment_submit_loading, payment_submit_loading, toggle_express_checkout_modal, express_payment_method }){
	const [loading, setLoading] = useState(true);
	const [expressError, setExpressError] = useState(undefined);
	const [waiverLoading, setWaiverLoading] = useState(true);
	const [waiverText, setWaiverText] = useState('');
	const [checkoutToken, setCheckoutToken] = useState(undefined);
	const [marketingEmails, setMarketingEmails] = useState(0);
	const [parentMarketingEmails, setParentMarketingEmails] = useState(0);
	const [guestCheckout, setGuestCheckout] = useState(undefined);

	const stripe = useStripe();
	const elements = useElements();

	useEffect(() => { checkLogin(); }, []);

	const expressCheckoutOptions = { billingAddressRequired: true, business: { name: company }, buttonType: {googlePay: 'checkout', applePay: 'check-out' }, emailRequired: true, layout: { maxColumns: 1, maxRows: 1, overflow: 'auto' }, paymentMethodOrder: ['apple_pay', 'google_pay'], paymentMethods: { amazonPay: 'never', applePay: 'auto', googlePay: 'auto', link: 'never', paypal: 'never' }, phoneNumberRequired: true };

	const handleConfirm = async (event) => {
		update_payment_submit_loading(true);
		console.log(event);

		if (!stripe || !elements){
			setExpressError({type: "validation_error", message: "The payment gateway has not loaded correctly. Please reload the page and try again."});
			update_payment_submit_loading(false);
			return;
		}

		const { billingDetails, billingContact } = event;
		const affiliate_value = cookie.get("affiliate_" + event_id);
		const stored = JSON.parse(localStorage.getItem('queue_token')) || null;
		let first_name = '';
		let last_name = '';
		let email_address = billingContact?.emailAddress || billingDetails?.email || "";
		let billing_country = '';
		let billing_address1 = '';
		let billing_address2 = '';
		let billing_city = '';
		let billing_state = '';
		let billing_postcode = '';

		if( billingDetails ){
			const raw_name = billingDetails?.name || "Guest";
			const name_parts = raw_name.trim().split(" ");
			first_name = name_parts[0];
			last_name = name_parts.length > 1 ? name_parts.slice(1).join(" ") : "Checkout"
			billing_country = billingDetails.address.country || "";
			billing_address1 = billingDetails.address.line1 || "";
			billing_address2 = billingDetails.address.line2 || "";
			billing_city = billingDetails.address.city || "";
			billing_state = billingDetails.address.state || "";
			billing_postcode = billingDetails.address.postal_code || "";
		}

		if( !isValidEmailFormat(email_address) || email_address.length < 4 ){
			setExpressError({type: "payment_error", message: "Please update the email address on your wallet account. It is currently invalid." }); update_payment_submit_loading(false); return;
		}

		const {error: submitError} = await elements.submit();
		if (submitError) { setExpressError({type: "payment_error", message: submitError.message }); update_payment_submit_loading(false); return; }

		const {error, confirmationToken} = await stripe.createConfirmationToken({ elements, params: { payment_method_data: { billing_details: billingDetails || billingContact }, return_url: 'https://' + window.location.hostname + '/checkout?event_url=' + event_url_string + '&token=' + getHoldToken() + '&payment_method_type=card&guest_checkout=' + guestCheckout } });
		if( error ){ setExpressError({type: "payment_error", message: error.message }); update_payment_submit_loading(false); return; }

		const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/protected/user/stripe/create_order', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: checkoutToken, 'Hold-Token': getHoldToken(), ...(affiliate_value && {'Affiliate-Code':affiliate_value}) }, body: JSON.stringify({ payment_method_type: 'card', confirmation_token: confirmationToken.id, url_string: event_url_string, event_id: event_id, first_name: first_name, last_name: last_name, email_address: billingDetails.email, hold_token: getHoldToken(), queue_token: stored?.token, guest_checkout: guestCheckout, verification: [], promotion_codes: [], date_of_birth: undefined, gender: undefined, order_answers: [], marketing_emails: marketingEmails, parent_marketing_emails: parentMarketingEmails, add_on: [], billing_country: billing_country, billing_address1: billing_address1, billing_address2: billing_address2, billing_city: billing_city, billing_state: billing_state, billing_postcode: billing_postcode }) }).catch(function(err){ setExpressError(err.error); update_payment_submit_loading(false); return; });
		if(!res.ok){ setExpressError({"message":'Invalid payment information. If the issue persists please try on a secondary device/browser.'}); update_payment_submit_loading(false); return; }
		const data = await res.json();
		console.log(data);
       	if(data.clear_queue_token === true){ localStorage.removeItem('queue_token'); } 
       	if(data.error){ setExpressError(data.error); update_payment_submit_loading(false); return; }
		handleServerResponse(data);
	}

	const handleServerResponse = async (response) => {
		console.log(response);
		if (response.error) {
			setExpressError({type: "payment_error", message: response.error.message });
		} else if (response.status === "requires_action") {
			const { error, paymentIntent } = await stripe.handleNextAction({ clientSecret: response.client_secret });
			if(error){
				setExpressError({type: "payment_error", message: response.error.message });
			} else {
				const affiliate_value = cookie.get("affiliate_" + event.event_id);
				fetch(process.env.NEXT_PUBLIC_API_URL + '/protected/user/stripe/confirm_order', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: checkoutToken, 'Hold-Token': getHoldToken(), ...(affiliate_value && {'Affiliate-Code':affiliate_value}) }, body: JSON.stringify({ payment_intent_id: paymentIntent.id, url_string: event_url_string, event_id: event_id, hold_token: getHoldToken() }) })
				.then(res => res.json())
				.then(data => { 
					if(data.error){
						setExpressError(data.error);
					} else {
						cookie.remove( "timeout_" + getHoldToken() );
						cookie.remove( 'intix_JSHQ688DNZ' );
						clearHoldToken();
						window.location.assign( '/checkout/confirmation?event_url=' + event_url_string + '&result=' + btoa(JSON.stringify(data)) );
					}
				})
				.catch((e) => { alert({type:"payment_error",message:e.message}); });
			}
		} else {
			cookie.remove( "timeout_" + getHoldToken() );
			cookie.remove( 'intix_JSHQ688DNZ' );
			clearHoldToken();
			window.location.assign( '/checkout/confirmation?event_url=' + event_url_string + '&result=' + btoa(JSON.stringify(response)) );
		}
	}
	
	const onReady = ({availablePaymentMethods}) => { if (!availablePaymentMethods){ setExpressError({"message":'You have no available payment methods. Please add a valid payment method and then try again.'}); setLoading(false); } else { setLoading(false); } };
	function checkLogin(){ 
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/me', { headers: { "Content-Type": "application/json", Authorization: cookie.get("token") } })
		.then((response) => { 
			if( !response.ok ){ getGuestToken(); setGuestCheckout(1); } 
			return response.json(); 
		}).then((data) => { 
			console.log(data);
			console.log(data.error);
			if( data.error ){ 
				getGuestToken();
				setGuestCheckout(1);
			} else { 
				setCheckoutToken( cookie.get("token") );
				setGuestCheckout(0);
				if( event_status_id === 1 ){ addReminder(); }
			} 
		}).catch(error => { getGuestToken(); setGuestCheckout(1); });
	}

	function getGuestToken(){ 
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/guest_checkout?hold_token=' + getHoldToken(), { headers: { "Content-Type": "application/json" } })
		.then((response) => { return response.json(); })
		.then((data) => { setCheckoutToken( data.token ); })
		.catch(error => { setCheckoutToken( undefined ); });
	}

	function isValidEmailFormat(email) {
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	return (
		<div className={styles.expressPurchaseOverlay}>
			<div className={styles.expressPurchaseModal} style={{backgroundColor:"#"+background_color,color:getContrast(background_color)}}>
				<div className={styles.expressPurchaseModalHeader}>
					<h2>Checkout</h2>
					<button className={styles.oorier} onClick={e => toggle_express_checkout_modal(false)}><CloseIcon style={{fill:getContrast(background_color),color:getContrast(background_color)}} /></button>
				</div>
				<div className={styles.expressPurchaseModalBody}>
					<div>
						<label className={styles.fEzXnj}>
							<div className={styles.checkboxLabel} onClick={e => marketingEmails === 0 ? setMarketingEmails(1) : setMarketingEmails(0)} style={{border:"1px solid " + getContrast(background_color)}}><label className={styles.checkboxContent}>{marketingEmails === 1 ? ( <Fragment><div className={styles.checkboxBackground} style={{backgroundColor:getContrast(background_color)}}></div><div className={styles.checkboxCheckmark}><CheckIcon style={{fill:"#"+ background_color}} /></div></Fragment> ) : null}</label></div>
							<span style={{color:getContrast(background_color)}}>Yes! I would like to receive communications about upcoming events, special offers or other information from {org_name}.</span>
						</label>
						{org_parent != undefined && org_parent != null ? (
							<label className={styles.fEzXnj}>
								<div className={styles.checkboxLabel} onClick={e => parentMarketingEmails === 0 ? setParentMarketingEmails(1) : setParentMarketingEmails(0)} style={{border:"1px solid " + getContrast(background_color)}}><label className={styles.checkboxContent}>{parentMarketingEmails === 1 ? ( <Fragment><div className={styles.checkboxBackground} style={{backgroundColor:getContrast(background_color)}}></div><div className={styles.checkboxCheckmark}><CheckIcon style={{fill:"#"+ background_color}} /></div></Fragment> ) : null}</label></div>
								<span style={{color:getContrast(background_color)}}>Yes! I would like to receive communications about upcoming events, special offers or other information from {org_parent.name}.</span>
							</label>
						) : null}
					</div>
					<h2><span>Total <CurrencySymbol currency={currency} />{( amount / 100 ).toFixed(2)}</span><span></span></h2>
                        <p>By completing this purchase you agree to the <a href="/legal/terms" target="_blank" style={{color:getContrast(background_color)}}>INTIX Terms & Conditions</a>, the <a href={"/"} style={{color:getContrast(background_color)}}>{event_title} Terms and Conditions</a> and <a href="/legal/privacy" target="_blank" style={{color:getContrast(background_color)}}>Privacy Policy</a>.</p>
                        <div className={styles.infoBox} style={{backgroundColor:getContrast(background_color)}}>
                            <InfoOutlined style={{color: getContrast(getContrast(background_color))}} />
                            {express_payment_method === 'apple_pay' &&
                                <span style={{color: getContrast(getContrast(background_color))}}>Please note: your ticket will be sent to the email address attached to your Apple Pay, <i>not</i> the email attached to your INTIX account.</span>
                            }
                            {express_payment_method === 'google_pay' &&
                                <span style={{color: getContrast(getContrast(background_color))}}>Please note: your ticket will be sent to the email address attached to your Google Pay, <i>not</i> the email attached to your INTIX account.</span>
                            }
                            {express_payment_method == undefined &&
                                <span style={{color: getContrast(getContrast(background_color))}}>Please note: your ticket will be sent to the email address attached to your express payment method, <i>not</i> the email attached to your INTIX account.</span>
                            }
                        </div>
					{expressError != undefined ? ( <div style={{marginTop: "16px"}}>{expressError.message}</div> ) : null}
				</div>
				<div className={styles.expressPurchaseModalFooter}>
					{loading || payment_submit_loading ? ( <div style={{textAlign:'center'}}><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/button-loading-transparent.svg" width="25" alt="Loading..." title="Loading..." /></div> ) : null}
					<ExpressCheckoutElement options={expressCheckoutOptions} onConfirm={handleConfirm} onReady={onReady} />
				</div>
			</div>
		</div>
	)
}

export function GeneralAdmissionNew({ event={"banner_image":undefined}, org={"background_color":"FFFFFF","favicon":undefined,"country_id":0}, stripe_account={"stripe_user_id":undefined}, venue, add_ons=[], questions=[], tracking_pixels=[], server_time }){
	const [error, setError] = useState(undefined);
	const [selected, setSelected] = useState([]);
	const [selectedLoading, setSelectedLoading] = useState(false);
	const [amount, setAmount] = useState(0);
	const [deliveryOption, setDeliveryOption] = useState(0);
	const [deliveryCost, setDeliveryCost] = useState(0);
	const [transactionFee, setTransactionFee] = useState(0);
	const [loadingCategories, setLoadingCategories] = useState(true);
	const [categories, setCategories] = useState([]);
	const [loading, setLoading] = useState(true);
	const [tickets, setTickets] = useState([]);
	const [filtered, setFiltered] = useState(undefined);
	const [displayUnlockedCodes, setDisplayUnlockedCodes] = useState(false);
	const [urlUnlockCode, setUrlUnlockCode] = useState(undefined);
	const [urlUnlockPromotion, setUrlUnlockPromotion] = useState(undefined);
	const [unlockedArray, setUnlockedArray] = useState([]);
	const [specialInstructionsLoading, setSpecialInstructionsLoading] = useState(true);
	const [specialInstructions, setSpecialInstructions] = useState(undefined);
	const [ticketDescriptions, setTicketDescriptions] = useState({});
	const [showApplePay, setShowApplePay] = useState(false);
  	const [showGooglePay, setShowGooglePay] = useState(false);
  	const [clientSecret, setClientSecret] = useState(undefined);
  	const [offerExpressCheckout, setOfferExpressCheckout] = useState(false);
  	const [expressCheckoutTotal, setExpressCheckoutTotal] = useState(0);
  	const [displayExpressCheckoutModal, setDisplayExpressCheckoutModal] = useState(false);
	const [paymentSubmitLoading, setPaymentSubmitLoading] = useState(false);
    const [expressPaymentMethod, setExpressPaymentMethod] = useState(undefined);
    const [companionRules, setCompanionRules] = useState([]);
	const [loadingCompanionRules, setLoadingCompanionRules] = useState(true);
	const [accepted, setAccepted] = useState(false);
	const [cartOpen, setCartOpen] = useState(false);
	const [openDescriptions, setOpenDescriptions] = useState([]);
	const [code, setCode] = useState('');
	const [codeLoading, setCodeLoading] = useState(false);
	const [codeError, setCodeError] = useState(undefined);

	const router = useRouter();

	useEffect(() => { 
		if( router.query.filter != undefined ){ setFiltered(router.query.filter.split(",").map(str => parseInt(str))); };
		if( router.query.unlock_code != undefined ){ setUrlUnlockCode( router.query.unlock_code ) };
		if( router.query.promotion_code != undefined ){ setUrlUnlockPromotion( router.query.promotion_code ) };
		if( router.query.affiliate_code != undefined ){ addAffiliateCookie( event.event_id, router.query.affiliate_code ); }
		if (router.isReady && router.query.token != undefined ){ const get_token = cookie.get("token"); if( get_token === undefined ){ cookie.set("token", router.query.token, { expires: 0.99, sameSite: 'none', secure: true, path: '/' }); } }
	}, [router.isReady]);
	useEffect(() => { runFilter(); }, [filtered,loading]);
	useEffect(() => { 
		if( event.absorb_ticket_fees === 0 ){
			setAmount(selected.reduce((total,item) => total + ( ( item.total_cost * item.tickets_included ) * item.units ), 0 ));
		} else {
			setAmount(selected.reduce((total,item) => total + ( ( ( item.total_cost * item.tickets_included ) - ( item.fees * item.tickets_included ) ) * item.units ), 0 ));
		}
	}, [selected]);
	useEffect(() => { calculateTransactionFee(); displayApplePayGooglePay(selected,amount); }, [amount]);
	useEffect(() => { 
		loadCategories(); 
		loadTickets();
		loadCompanionRules();
		offerExpressCheckoutCheck();
		if (typeof window !== 'undefined'){
			const navigationEntries = performance.getEntriesByType('navigation');
			if( navigationEntries.length > 0 && navigationEntries[0].type === 'reload' ){
				// if reload - clear cart
				cookie.remove( "timeout_" + getHoldToken() );
				cookie.remove( 'intix_JSHQ688DNZ' );
				clearHoldToken();
			}
		}
	}, []);
	useEffect(() => { fetch('https://d2jun3ty2bmcrf.cloudfront.net/event/' + event.event_id + '/special_instructions.txt').then(response => response.ok ? response.text() : undefined).then(text => { setSpecialInstructions(text); }).catch(error => { }).finally(() => { setSpecialInstructionsLoading(false); }); }, []);
	useEffect(() => { if(tickets.length > 0 ){ if(tracking_pixels.some(e => e.type === 'google_tag') || tracking_pixels.some(e => e.type === 'google_analytics')){ for(var z = 0; z < tickets.length; z++){ gtag.event('view_item', {currency: event.currency, items: [{item_id: tickets[z].price_id, item_name: tickets[z].title, affiliation: event.title, price: ( tickets[z].total_cost / 100 ).toFixed(2), index: 0 }]}); } } } }, [tickets, tracking_pixels]);

	function displayApplePayGooglePay( selected, amount ){
		if( selected.length === 0 ){ setShowApplePay(false); setShowGooglePay(false); return; }
		if( amount === 0 ){ setShowApplePay(false); setShowGooglePay(false); return; }
		if( window.ApplePaySession && window.ApplePaySession.canMakePayments() ){ setShowApplePay(true); }
		if( window.PaymentRequest ){
			const request = new PaymentRequest([{
				supportedMethods: 'https://google.com/pay',
				data: {
					apiVersion: 2, apiVersionMinor: 0,
					allowedPaymentMethods: [{
						type: 'CARD',
						parameters: { allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'], allowedCardNetworks: ['VISA', 'MASTERCARD', 'AMEX'] },
						tokenizationSpecification: { type: 'PAYMENT_GATEWAY', parameters: { gateway: 'stripe', 'stripe:publishableKey': getStripePublicKey({country_id:org.country}) } }
					}]
				}
			}], { total: { label: 'Total', amount: { currency: event.currency, value: ( amount / 100 ).toFixed(2) } } });

			request.canMakePayment().then(result => { if( result ){ setShowGooglePay(true); } }).catch(error => { console.log("Google Pay check skipped"); console.log(error); });
		}
	}

	function handleUnitsOnChange(title,price_category_id,price_id,total_cost,units,fees,group_ticket,tickets_included){
		setError(undefined);
		setSelected(prevSelected => {
	        let data = [...prevSelected];
	        let selectedIndex = data.findIndex(d => d.price_id == price_id);
	        
	        if (selectedIndex !== -1) {
	            data[selectedIndex] = { ...data[selectedIndex], units };
	            if (units == '0' || parseInt(units) === 0) {
	                data.splice(selectedIndex, 1);
	                gtag.event('remove_from_cart', { id: price_id, name: title, category: price_category_id, price: (total_cost / 100).toFixed(2), quantity: 0 });
	            }
	        } else {
	            data.push({ title, price_category_id, price_id, total_cost, fees, units, group_ticket, tickets_included });
	            if (tracking_pixels.some(e => e.type === 'facebook')) { fbq.event('AddToCart', { content_name: title, content_category: price_category_id, content_ids: [price_id], content_type: 'product', value: (total_cost / 100).toFixed(2), currency: event.currency }); }
	            if (tracking_pixels.some(e => e.type === 'google_tag') || tracking_pixels.some(e => e.type === 'google_analytics')) { gtag.event('add_to_cart', { currency: event.currency, value: ((total_cost / 100) * units).toFixed(2), items: [{ item_id: price_id, item_name: title, affiliation: event.title, price: (total_cost / 100).toFixed(2), quantity: units }] }); }
	            if (tracking_pixels.some(e => e.type === 'tiktok')) { ttq.track('AddToCart', { content_id: price_id, description: title, quantity: 1, currency: event.currency, value: (total_cost / 100).toFixed(2) }); }
	        }
	        
	        return validateGaCartRules(data);
	    });
	}

	function submitCheckoutZero(){
		setSelectedLoading(true);
		setTimeout(() => {
			fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/add_general_admission', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() }, body: JSON.stringify({ selected_prices: selected, event_id: event.event_id, hold_token: parseInt( getHoldToken() ), timeout: event.purchase_timeout }) })
			.then(response => response.json())
			.then(data => { if(data.error){ setError(data.error.message); setSelectedLoading(false); } else { window.location.assign( '/checkout/?event_url=' + event.url_string + "&token=" + getHoldToken() + ( ( urlUnlockPromotion != undefined ) ? ( "&promotion_code=" + urlUnlockPromotion ) : '') ); fbq.event('InitiateCheckout',{}); gtag.event('begin_checkout',{currency: event.currency, value: ( data.cart_value / 100 ).toFixed(2), items:[]}); if(tracking_pixels.some(e => e.type === 'tiktok')){ ttq.track('InitiateCheckout',{}); } } })
			.catch(error => { setError(error.message); });
		}, Math.random() * 4000);
	}

	function submitExpressCheckoutButton(){
		setSelectedLoading(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/add_general_admission', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() }, body: JSON.stringify({ selected_prices: selected, event_id: event.event_id, hold_token: parseInt( getHoldToken() ), timeout: event.purchase_timeout }) })
		.then(response => response.json())
		.then(data => { 
			if(data.error){ 
				setError(data.error.message); 
				setSelectedLoading(false); 
			} else { 
				fbq.event('InitiateCheckout',{}); 
				gtag.event('begin_checkout',{currency: event.currency, value: ( data.cart_value / 100 ).toFixed(2), items:[]}); 
				if(tracking_pixels.some(e => e.type === 'tiktok')){ ttq.track('InitiateCheckout',{}); }
				fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/express_checkout_session', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Authorization': cookie.get("token"), 'Hold-Token': getHoldToken() }, })
				.then(response => response.json())
				.then(data => { setClientSecret(data.client_secret); setExpressCheckoutTotal(data.checkout_total); setDisplayExpressCheckoutModal(true); })
				.catch(error => { setError('There was an error creating the transaction. Please try another payment method.'); setSelectedLoading(false); });
			} 
		})
		.catch(error => { setError(error.message); });
	}

	function calculateTransactionFee(){
		if( amount > 0 ){
			setSelectedLoading(true);
			fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/cart_transaction_fee?amount=' + amount, { method: 'GET', headers: { 'Content-Type': 'application/json', 'Hold-Token': getHoldToken() } })
			.then(response => response.json())
			.then(data => { setTransactionFee(data) })
			.catch(error => { setError(error.message); })
			.finally(() => { setSelectedLoading(false); });
		} else {
			setTransactionFee(0)
		}
	}

	function loadCategories(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/ticket_category', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.json())
		.then(data => { if(data.error){  } else { setCategories(data); } })
		.catch(error => { setError(error.message); })
		.finally(() => { setLoadingCategories(false); });
	}

	function loadTickets(){
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/general_admission', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.json())
		.then(res => { 
			if(res.error){  

			} else { 
				setTickets(res.data);
				Promise.all(res.data.map(t =>
					fetch('https://d2jun3ty2bmcrf.cloudfront.net/event/' + event.event_id + '/price_category/' + t.price_category_id + '/price/' + t.price_id + '/description.txt')
					.then(response => response.ok ? response.text() : null)
					.then(text => ({ id: t.price_id, text: text }))
					.catch(() => ({ id: t.price_id, text: null }))
				)).then(results => {
					setTicketDescriptions(results.reduce((acc, curr) => ({...acc, [curr.id]: curr.text}), {}));
				});

				setDisplayUnlockedCodes(res.locked_tickets); 
				if( res.data.length === 1 && res.data[0].max_units === 1 && res.locked_tickets === false ){ 
					handleUnitsOnChange( res.data[0].title, res.data[0].price_category_id, res.data[0].price_id, res.data[0].total_cost, 1, res.data[0].fees, res.data[0].group_ticket, res.data[0].tickets_included ); 
				} 
			} 
		})
		.catch(error => { setError(error.message); })
		.finally(() => { setLoading(false); });
	}

	function loadCompanionRules() {
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/companion_ticketing', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
		.then(response => response.ok ? response.json() : Promise.reject('fetch error'))
		.then(data => { if (!data.error) setCompanionRules(data.data); updateTicketsMap(); })
		.catch(error => { console.log(error); })
		.finally(() => { setLoadingCompanionRules(false); });
	}

	function validateGaCartRules(currentCart) {
	    if (!companionRules || companionRules.length === 0) return currentCart;
	    let validCart = [...currentCart];

	    companionRules.forEach(rule => {
	        const cartCounts = validCart.reduce((acc, item) => {
				acc[item.price_id] = (acc[item.price_id] || 0) + parseInt(item.units || 0);
				return acc;
			}, {});

	        const maxAllowed = Math.min(
	            ...rule.requirements.map(req => 
	                Math.floor((cartCounts[req.trigger_price_id] || 0) / req.trigger_quantity)
	            )
	        ) * rule.reward_quantity;
	        const currentRewardCount = cartCounts[rule.reward_price_id] || 0;

	        if (currentRewardCount > maxAllowed) {
	            let excessToRemove = currentRewardCount - maxAllowed;
	            
	            // Walk backwards through cart, reducing units on reward lines
	            for (let i = validCart.length - 1; i >= 0 && excessToRemove > 0; i--) {
	                if (validCart[i].price_id !== rule.reward_price_id) continue;
	                const lineUnits = parseInt(validCart[i].units || 0);
	                
	                if (lineUnits <= excessToRemove) {
						excessToRemove -= lineUnits;
						validCart.splice(i, 1);
					} else {
						validCart[i] = { ...validCart[i], units: lineUnits - excessToRemove };
						excessToRemove = 0;
					}
	            }
	        }
	    });

	    return validCart;
	}

	function runFilter(){
		if( filtered != undefined && loading === false ){ setTickets(tickets.filter(item => filtered.find(obj => obj === item.price_category_id))) }
	}

	function openTicketSales(){ window.location.reload(false); }
	function unlockCodeCorrect(array){ setUnlockedArray(array); }
	function togglePaymentSubmitLoading( value ){ setPaymentSubmitLoading(value); }
	function toggleExpressCheckoutModal( value ){ 
		setDisplayExpressCheckoutModal(value); 
		setSelectedLoading(value); 
		//cookie.remove( "timeout_" + getHoldToken() );
		//cookie.remove( 'intix_JSHQ688DNZ' );
		//clearHoldToken();
		//setSelected([]);
	}
	function offerExpressCheckoutCheck(){
		if( add_ons.length > 0 ){ setOfferExpressCheckout(false); return; }
		if( questions.length > 0 ){ setOfferExpressCheckout(false); return; }
		if( event.offer_guest_checkout ){ setOfferExpressCheckout(true); }
	}

	useEffect(() => { if( displayUnlockedCodes && urlUnlockCode != undefined && urlUnlockCode != '' ){ setCode(urlUnlockCode); validateCode(urlUnlockCode); } }, [displayUnlockedCodes, urlUnlockCode]);

	function changeUnits( item, units ){
		if( units === 0 && !selected.some(line => line.price_id === item.price_id) ){ return; }
		handleUnitsOnChange( item.title, item.price_category_id, item.price_id, item.total_cost, units, item.fees, item.group_ticket, item.tickets_included );
	}

	function validateCode( value ){
		setCodeLoading(true);
		fetch(process.env.NEXT_PUBLIC_API_URL + '/public/events/' + event.event_id + '/general_admission/unlock', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password: value }) })
		.then(response => response.json())
		.then(data => { if(data.error){ setCodeError(data.error.message); } else { unlockCodeCorrect(data.data); setAccepted(true); } })
		.catch(error => { setCodeError(error.message); })
		.finally(() => { setCodeLoading(false); });
	}

	const isRegistration = event.event_type === 1;
	const basketWord = org.country == 196 ? 'basket' : 'cart';

	if( !server_time || server_time < event.utc_booking_start_date || server_time > event.utc_booking_finish_date ){
		return (
			<NewLookPage event={event} org={org} venue={venue} tracking_pixels={tracking_pixels}>
				<div className={styles.content}>
					<section className={styles.card}>
						<p className={styles.eyebrow}>{isRegistration ? 'Registrations' : 'Tickets'}</p>
						<h2 className={styles.groupTitle}>{server_time > event.utc_booking_finish_date ? ( isRegistration ? 'Online registrations have closed' : 'Online sales have closed' ) : 'Not on sale right now'}</h2>
						{server_time > event.utc_booking_finish_date ? ( event.ticket_resale === 1 ? ( <Link href={"/event/" + event.url_string + "/resale"} className={styles.ghostButton}>Check resale</Link> ) : null ) : ( <p className={styles.note}>Refresh this page to check again.</p> )}
					</section>
				</div>
			</NewLookPage>
		)
	}

	const groups = [];
	categories.forEach(category => {
		const rows = tickets.filter(t => t.ticket_category_id === category.ticket_category_id).concat(unlockedArray.filter(t => t.ticket_category_id === category.ticket_category_id).map(t => ({ ...t, unlocked: true })));
		if( rows.length > 0 ){ groups.push({ ticket_category_id: category.ticket_category_id, title: category.title, banner_image: category.banner_image, rows: rows }); }
	});
	const uncategorised = tickets.filter(t => t.ticket_category_id === 0).concat(unlockedArray.filter(t => t.ticket_category_id === 0).map(t => ({ ...t, unlocked: true })));
	if( uncategorised.length > 0 ){ groups.push({ ticket_category_id: 0, title: isRegistration ? 'Registration options' : ( groups.length > 0 ? 'More tickets' : 'Tickets' ), banner_image: null, rows: uncategorised }); }

	const cartUnits = selected.reduce((total, item) => total + parseInt(item.units), 0);
	const cartFees = event.absorb_ticket_fees === 0 ? selected.reduce((total, item) => total + ( item.fees * item.tickets_included * item.units ), 0) : 0;
	const cartTotal = selected.reduce((total, item) => total + ( priceOf(item, event) * item.units ), 0) + ( event.absorb_transaction_fees === 0 ? transactionFee : 0 );
	const wallet = offerExpressCheckout && amount > 0 ? ( showApplePay ? 'apple_pay' : ( showGooglePay ? 'google_pay' : null ) ) : null;
	const cartSheet = cartOpen && selected.length > 0;

	return (
		<Fragment>
			<NewLookPage event={event} org={org} venue={venue} tracking_pixels={tracking_pixels}>
				<div className={styles.content}>
					<div className={styles.mainCol}>
						{error != undefined ? ( <div className={styles.errorCard} role="alert" dangerouslySetInnerHTML={{__html: error}}></div> ) : null}
						{loadingCategories === true || loading === true ? (
							<section className={styles.card} aria-busy="true"><div className={styles.skeletonShort}></div><div className={styles.skeletonRow}></div><div className={styles.skeletonRow}></div><div className={styles.skeletonRow}></div></section>
						) : (
							<Fragment>
								{specialInstructions != undefined && specialInstructions != '' ? ( <section className={styles.card}><p className={styles.eyebrow}>Good to know</p><div className={styles.richText} dangerouslySetInnerHTML={{__html:specialInstructions}}></div></section> ) : null}
								{displayUnlockedCodes ? (
									<section className={styles.card}>
										<form onSubmit={e => { e.preventDefault(); validateCode( code ); }}>
											<label className={styles.fieldLabel} htmlFor={"promo_code_input_" + event.event_id}>Have a code?</label>
											<div className={styles.codeRow}>
												<input id={"promo_code_input_" + event.event_id} className={styles.codeInput} disabled={accepted || codeLoading} onChange={e => { setCode(e.target.value); setCodeError(undefined); }} value={code} type="text" placeholder="Enter code" name="promo-code" autoComplete="off" />
												{accepted === true ? ( <button id={"promo_code_remove_" + event.event_id} type="button" className={styles.ghostButton} onClick={e => { setAccepted(false); unlockCodeCorrect([]); }}>Remove</button> ) : ( <button id={"promo_code_submit_" + event.event_id} type="submit" className={styles.ghostButton} disabled={code.length < 2 || codeLoading}>Apply</button> )}
											</div>
											{codeError != undefined ? ( <p className={styles.codeError} role="alert">{codeError}</p> ) : null}
											{accepted === true ? ( <p className={styles.codeOk}><CheckCircleOutline />{code} applied. What it unlocks is now showing.</p> ) : null}
										</form>
									</section>
								) : null}
								{groups.map(group => (
									<section className={styles.card} key={"group_" + group.ticket_category_id}>
										{group.banner_image != null ? ( <img className={styles.categoryImage} src={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + group.banner_image} alt="" /> ) : null}
										<h2 className={styles.groupTitle}>{group.title}</h2>
										<ul className={styles.rows}>
											{group.rows.map(item => {
												const units = selected.some(line => line.price_id === item.price_id) ? parseInt(selected.find(line => line.price_id === item.price_id).units) : 0;
												const rule = companionRules?.find(r => r.reward_price_id === item.price_id);
												const max = rule ? Math.min(item.tickets_remaining, item.max_units, Math.floor(companionAllowance(rule, selected) / ( item.tickets_included || 1 ))) : Math.min(item.tickets_remaining, item.max_units);
												const firstUnit = Math.max(1, item.min_units);
												const options = [];
												for (let i = firstUnit; i <= Math.max(max, units); i++){ options.push(i); }
												return (
													<li className={styles.row} key={"row_" + item.price_id + ( item.unlocked ? "_unlocked" : "" )}>
														<div className={styles.rowMain}>
															<p className={styles.name}>{item.title}</p>
															{item.unlocked || ( item.sold_out === 0 && item.tickets_remaining < 15 ) ? (
																<div className={styles.badges}>
																	{item.unlocked ? ( <span className={styles.badgeGood}>Unlocked</span> ) : null}
																	{item.sold_out === 0 && item.tickets_remaining < 15 ? ( <span className={styles.badge}>{isRegistration ? 'Last available' : 'Last tickets'}</span> ) : null}
																</div>
															) : null}
															{rule ? ( companionAllowance(rule, selected) === 0 ? (
																<p className={styles.lockLine}><LockOutlined />{rule.title ? rule.title + ': add ' : 'Add '}{rule.requirements.map(req => req.trigger_quantity + ' × ' + ( tickets.find(t => t.price_id === req.trigger_price_id)?.title || 'qualifying ticket' )).join(' and ')} to unlock{rule.reward_quantity > 1 ? ' up to ' + rule.reward_quantity : ''}</p>
															) : (
																<p className={styles.unlockLine}><CheckCircleOutline />{rule.title ? rule.title + ': ' : ''}{companionAllowance(rule, selected)} available with your {basketWord}</p>
															) ) : null}
															{ticketDescriptions[item.price_id] ? (
																<Fragment>
																	<div id={"description_" + item.price_id} className={openDescriptions.includes(item.price_id) ? styles.descOpen : styles.desc} dangerouslySetInnerHTML={{__html: ticketDescriptions[item.price_id].replace(/<p>(\s|&nbsp;)*<\/p>/g, '')}}></div>
																	{ticketDescriptions[item.price_id].replace(/<[^>]*>/g, '').length > 90 ? ( <button type="button" className={styles.more} aria-expanded={openDescriptions.includes(item.price_id)} aria-controls={"description_" + item.price_id} onClick={e => setOpenDescriptions( openDescriptions.includes(item.price_id) ? openDescriptions.filter(id => id !== item.price_id) : openDescriptions.concat([item.price_id]) )}>{openDescriptions.includes(item.price_id) ? 'Show less' : 'Show more'}</button> ) : null}
																</Fragment>
															) : null}
														</div>
														<div className={styles.price}>
															{event.ticket_resale === 1 && item.ticket_resale === 1 && item.sold_out === 1 ? (
																<span className={styles.priceValue}>Sold out</span>
															) : priceOf(item, event) === 0 ? (
																<span className={styles.priceValue}>Free</span>
															) : (
																<Fragment>
																	<span className={styles.priceValue}><CurrencySymbol currency={event.currency} />{( priceOf(item, event) / 100 ).toFixed(2)}</span>
																	{event.absorb_ticket_fees === 0 && item.fees > 0 ? ( <span className={styles.priceNote}>incl. <CurrencySymbol currency={event.currency} />{( ( item.fees * item.tickets_included ) / 100 ).toFixed(2)} booking fee</span> ) : null}
																</Fragment>
															)}
														</div>
														<div className={styles.qty}>
															{item.sold_out !== 0 ? ( event.ticket_resale === 1 && item.ticket_resale === 1 ? ( <Link href={"/event/" + event.url_string + "/resale"} className={styles.soldChip}>Check resale</Link> ) : ( <span className={styles.soldChip}>Sold out</span> ) ) : (
																<div className={units > 0 ? styles.stepperOn : styles.stepper} role="group" aria-label={"Quantity for " + item.title}>
																	<button type="button" aria-label={"Remove one " + item.title} disabled={selectedLoading || units === 0} onClick={e => changeUnits(item, units - 1 < firstUnit ? 0 : units - 1)}><Remove /></button>
																	<span className={styles.quickPick}>
																		<select aria-label={"Choose how many " + item.title} value={units} disabled={selectedLoading || options.length === 0} onChange={e => changeUnits(item, parseInt(e.target.value))}>
																			<option value={0}>0</option>
																			{options.map(option => ( <option key={"units_" + item.price_id + "_" + option} value={option}>{option}</option> ))}
																		</select>
																		<KeyboardArrowDown />
																	</span>
																	<button type="button" aria-label={"Add one " + item.title} disabled={selectedLoading || ( units === 0 ? firstUnit > max : units >= max )} onClick={e => changeUnits(item, units === 0 ? firstUnit : units + 1)}><Add /></button>
																</div>
															)}
														</div>
													</li>
												)
											})}
										</ul>
										{group.rows.every(t => t.sold_out !== 0) ? (
											<div className={styles.groupFoot}>
												<p>Everything in this category is sold out.</p>
												{event.ticket_resale === 1 ? ( <Link href={"/event/" + event.url_string + "/resale"} className={styles.ghostButton}>Check resale</Link> ) : null}
											</div>
										) : null}
									</section>
								))}
								{groups.length === 0 ? (
									<section className={styles.card}>
										<h2 className={styles.groupTitle}>There are currently no {isRegistration ? "registration options" : "tickets"} available</h2>
										{event.ticket_resale === 1 ? ( <Link href={"/event/" + event.url_string + "/resale"} className={styles.ghostButton}>Check resale</Link> ) : null}
									</section>
								) : null}
							</Fragment>
						)}
					</div>
					<aside className={styles.sideCol}>
						{cartSheet ? ( <button type="button" className={styles.sheetDim} aria-label={"Close " + basketWord} onClick={e => setCartOpen(false)}></button> ) : null}
						<section className={cartSheet ? styles.cartCardOpen : styles.cartCard} aria-label={"Your " + basketWord}>
							<div className={styles.sheetHead}>
								<p className={styles.eyebrow}>Your {basketWord}</p>
								<button type="button" className={styles.sheetClose} aria-label={"Close " + basketWord} onClick={e => setCartOpen(false)}><CloseIcon /></button>
							</div>
							{selected.length === 0 ? (
								<Fragment>
									<p className={styles.emptyTitle}>{basketWord === 'basket' ? 'Basket' : 'Cart'} empty</p>
									<p className={styles.note}>Use + or tap the number next to a {isRegistration ? 'registration' : 'ticket'} to add it.</p>
								</Fragment>
							) : (
								<Fragment>
									<dl className={selectedLoading ? styles.sumLoading : styles.sum}>
										{selected.map(item => (
											<div className={styles.sumRow} key={"line_" + item.price_id}>
												<dt>{item.units} × {item.title}</dt>
												<dd>{priceOf(item, event) === 0 ? 'Free' : ( <Fragment><CurrencySymbol currency={event.currency} />{( ( priceOf(item, event) * item.units ) / 100 ).toFixed(2)}</Fragment> )}</dd>
											</div>
										))}
										{event.absorb_transaction_fees === 0 && transactionFee > 0 ? ( <div className={styles.sumRow}><dt>Transaction fee</dt><dd><CurrencySymbol currency={event.currency} />{( transactionFee / 100 ).toFixed(2)}</dd></div> ) : null}
										<div className={styles.sumTotal}><dt>Total</dt><dd><CurrencySymbol currency={event.currency} />{( cartTotal / 100 ).toFixed(2)}</dd></div>
									</dl>
									{cartFees > 0 ? ( <p className={styles.note}>Prices include <CurrencySymbol currency={event.currency} />{( cartFees / 100 ).toFixed(2)} in booking fees.</p> ) : null}
								</Fragment>
							)}
							<div className={styles.cartActions}>
								{selected.reduce((total, item) => total + ( parseInt(item.units) * item.tickets_included ), 0) > 8 && event.send_pdf_ticket === 1 ? ( <p className={styles.pdfNote}>Orders of more than 8 tickets are not emailed as PDFs. Every ticket will be in your INTIX account and the INTIX app.</p> ) : null}
								<button type="button" className={styles.cta} disabled={selected.length === 0 || selectedLoading} onClick={e => submitCheckoutZero()}>{ selectedLoading === true && selected.length > 0 ? ( <img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/button-loading.svg" width="25" alt="Loading..." title="Loading..." /> ) : isRegistration ? 'Continue' : 'Checkout'}</button>
								{wallet ? (
									<Fragment>
										<p className={styles.or}>or pay with</p>
										<button type="button" className={styles.wallet} disabled={selectedLoading} onClick={e => { submitExpressCheckoutButton(); setExpressPaymentMethod(wallet); }}><img src={wallet === 'apple_pay' ? '/images/apple_pay.svg' : '/images/google_pay.svg'} alt={wallet === 'apple_pay' ? 'Pay with Apple Pay' : 'Pay with Google Pay'} /></button>
										<p className={styles.note}>Express pay sends your {isRegistration ? 'confirmation' : 'tickets'} to the email on your {wallet === 'apple_pay' ? 'Apple Pay' : 'Google Pay'} account.</p>
									</Fragment>
								) : null}
								<p className={styles.note}>We hold your {isRegistration ? 'places' : 'tickets'} for <b>{event.purchase_timeout} minutes</b> once you press {isRegistration ? 'Continue' : 'Checkout'}. {isRegistration ? 'Registrations' : 'Tickets'} are not secured until payment has been made.</p>
							</div>
						</section>
						<section className={styles.card}>
							<div className={styles.trustItem}><LockOutlined /><p><strong>Secure checkout</strong>{event.event_category_id === 24 ? 'Bank-level security on every payment, so buying is the easiest part of your matchday.' : 'Bank-level security, end-to-end encryption, total peace of mind on every payment.'}</p></div>
							<div className={styles.trustItem}><PhoneIphone /><p><strong>Tickets on your phone</strong>{event.digital_ticket === 1 ? 'Digital tickets sit in your account the moment you pay.' : 'Your order is confirmed by email as soon as you pay.'}</p></div>
							<div className={styles.trustItem}><VerifiedUser /><p><strong>Bought direct</strong>You are buying from {org.name}, not a resale marketplace.</p></div>
						</section>
					</aside>
				</div>
				<div className={styles.bar}>
					{selected.length === 0 ? (
						<div className={styles.barInfo}><b>{basketWord === 'basket' ? 'Basket' : 'Cart'} empty</b><span>Tap + to add</span></div>
					) : (
						<button type="button" className={styles.barInfo} aria-expanded={cartOpen} onClick={e => setCartOpen(true)}>
							<b>{cartTotal === 0 ? 'Free' : ( <Fragment><CurrencySymbol currency={event.currency} />{( cartTotal / 100 ).toFixed(2)}</Fragment> )}</b>
							<span>{cartUnits} {isRegistration ? ( cartUnits === 1 ? 'registration' : 'registrations' ) : ( cartUnits === 1 ? 'ticket' : 'tickets' )} · View {basketWord}<KeyboardArrowUp /></span>
						</button>
					)}
					<div className={styles.barActions}>
						{wallet && selected.length > 0 ? ( <button type="button" className={styles.walletSmall} disabled={selectedLoading} onClick={e => { submitExpressCheckoutButton(); setExpressPaymentMethod(wallet); }}><img src={wallet === 'apple_pay' ? '/images/apple_pay.svg' : '/images/google_pay.svg'} alt={wallet === 'apple_pay' ? 'Pay with Apple Pay' : 'Pay with Google Pay'} /></button> ) : null}
						<button type="button" className={styles.cta} disabled={selected.length === 0 || selectedLoading} onClick={e => submitCheckoutZero()}>{ selectedLoading === true && selected.length > 0 ? ( <img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/button-loading.svg" width="25" alt="Loading..." title="Loading..." /> ) : isRegistration ? 'Continue' : 'Checkout'}</button>
					</div>
				</div>
			</NewLookPage>
			{displayExpressCheckoutModal ? ( <ExpressCheckoutElements stripe_promise={loadStripe(getStripePublicKey({country_id:org.country}),{stripeAccount:stripe_account.stripe_user_id})} event_id={event.event_id} event_title={event.title} event_status_id={event.event_status_id} event_url_string={event.url_string} background_color={org.background_color} org_name={org.name} company={org.company} org_parent={org.parent} currency={event.currency} amount={expressCheckoutTotal} update_payment_submit_loading={togglePaymentSubmitLoading} payment_submit_loading={paymentSubmitLoading} toggle_express_checkout_modal={toggleExpressCheckoutModal} express_payment_method={expressPaymentMethod} /> ) : null}
			{paymentSubmitLoading ? ( <div className={styles.dWatLN} style={{backgroundImage:"url('https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + event.banner_image + "')"}}><div className={styles.pUNm5g}><div className={styles.bavcr5z}><div className={styles.kLLpnb7}><img className={styles.lpunh5} src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/secure-payment-processing.svg" alt="" border={0} /></div></div><div className={styles.gabNya}>Payment Processing...<br /><span>Please don't refresh this page whilst we process your booking</span></div><div className={styles.tTgbhn7y}>Loading...</div></div></div> ) : null}
		</Fragment>
	)
}

function priceOf( item, event ){ return ( event.absorb_ticket_fees === 0 ? item.total_cost : item.total_cost - item.fees ) * item.tickets_included; }

function companionAllowance( rule, selected ){
	return Math.min( ...rule.requirements.map(req => Math.floor( selected.filter(line => line.price_id === req.trigger_price_id).reduce((total, line) => total + ( parseInt(line.units || 0) * ( line.tickets_included || 1 ) ), 0) / req.trigger_quantity )) ) * rule.reward_quantity;
}

export function NewLookPage({ event, org, venue, tracking_pixels = [], status, children }){
	return (
		<Fragment>
			<Head>
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="x-default" />
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="en" />
				<link rel="alternate" href={"https://www.intix.com/event/" + event.url_string} hrefLang="en-us" />
				<link rel="alternate" href={"https://www.intix.com.au/event/" + event.url_string} hrefLang="en-au" />
				<link rel="alternate" href={"https://www.intix.co.uk/event/" + event.url_string} hrefLang="en-gb" />
				<link rel="alternate" href={"https://www.intix.co.nz/event/" + event.url_string} hrefLang="en-nz" />
				<link rel="alternate" href={"https://www.intix.ch/event/" + event.url_string} hrefLang="gsw" />
				{tracking_pixels.filter(e => e.type == 'facebook').map((item,index) => ( <script key={"facebook_pixel_" + index} id={"fb-pixel-" + index} dangerouslySetInnerHTML={{__html:`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', ${item.pixel});` }} /> ))}
				{tracking_pixels.filter(e => e.type == 'google_analytics').map((item,index) => ( <Fragment key={"ga4-" + index}><script async src={"https://www.googletagmanager.com/gtag/js?id=" + item.pixel}></script><script key={"google_analytics_" + index} id={"google-tag-" + index} dangerouslySetInnerHTML={{__html:`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${item.pixel}');` }} /></Fragment> ))}
				{tracking_pixels.filter(e => e.type == 'google_tag').map((item,index) => ( <Fragment key={"gtm-" + index}><script async src={"https://www.googletagmanager.com/gtag/js?id=" + item.pixel}></script><script key={"google_tag_" + index} id={"gtm-" + index} dangerouslySetInnerHTML={{__html:`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${item.pixel}');` }} /></Fragment> ))}
				{tracking_pixels.filter(e => e.type == 'tiktok').map((item,index) => ( <script key={"tiktok_" + index} id={"tiktok-tag-" + index} dangerouslySetInnerHTML={{__html:`!function (w, d, t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};ttq.load('${item.pixel}');ttq.page();}(window, document, 'ttq');` }} /> ))}
				<meta name="theme-color" content={"#" + org.background_color} />
			</Head>
			<div id={"ticketSelect"} className={styles.page + " " + archivoBlack.variable + " " + manrope.variable + " " + jetbrainsMono.variable} style={{ '--org': '#' + org.background_color, '--orgInk': getContrast(org.background_color) }}>
				<div className={styles.topBar}>{ org.logo_image != null && org.logo_image.length > 0 ? ( <a href={"/org/" + org.url_string}><img src={"https://d2jun3ty2bmcrf.cloudfront.net/org/" + org.url_string + "/" + org.logo_image} alt={org.name} /></a> ) : ( <a href="/"><img src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/logo-small-console.png" alt="INTIX" /></a> ) }</div>
				<header className={styles.hero}>
					{org.background_image != null && org.background_image.length > 0 ? ( <div className={styles.heroBackdrop} style={{ backgroundImage: "url('https://d2jun3ty2bmcrf.cloudfront.net/org/" + org.url_string + "/" + org.background_image + "')" }} aria-hidden="true"></div> ) : null}
					<div className={styles.heroInner}>
						<img className={styles.banner} src={"https://d2jun3ty2bmcrf.cloudfront.net/event/" + event.event_id + "/" + event.banner_image} alt={event.title} width={2160} height={1220} />
						<div className={styles.heroText}>
							{status ? null : (
								<ol className={styles.steps}>
									<li><Link href={"/event/" + event.url_string + "/information"} prefetch={false}>Event info</Link></li>
									<li className={styles.stepOn} aria-current="step">{event.event_type === 1 ? 'Registration' : 'Tickets'}</li>
									<li>Payment</li>
								</ol>
							)}
							<div className={styles.headRow}>
								<div className={styles.dateBlock}><p>{event.formatted_event_start_month}</p><p className={styles.dateDay}>{event.formatted_event_start_date}</p><p>{event.formatted_event_start_day}</p></div>
								<div className={styles.headMain}>
									<h1 className={styles.title}>{event.title}</h1>
									<p className={styles.meta}>
										{event.ga_event_start_date === event.ga_event_finish_date ? ( <span className={styles.metaTime}>{DateTime.fromMillis(event.utc_event_start_date * 1000, { zone: event.timezone }).toFormat('h:mm a')}{event.online_event === 1 ? " (" + event.timezone + ")" : ""} · </span> ) : null}
										{event.online_event === 1 ? 'Online event' : ( event.venue_id != null && venue.title ? venue.title.trim() : 'Venue to be announced' )}
										{event.online_event !== 1 && venue.suburb ? ( <span className={styles.metaSuburb}>, {venue.suburb}</span> ) : null}
									</p>
									<div className={styles.chips}>
										{status ? ( <span className={styles.chipSolid}>{status}</span> ) : null}
										<span className={styles.chip}>General admission</span>
										{event.digital_ticket === 1 ? ( <span className={styles.chip}>{event.print_ticket === 1 ? 'Digital or print ticket' : 'Digital ticket'}</span> ) : null}
										{event.ticket_resale === 1 ? ( <span className={styles.chip}>Resale available</span> ) : null}
									</div>
								</div>
							</div>
						</div>
					</div>
				</header>
				{children}
			</div>
		</Fragment>
	)
}
